const en = {
    // Navigation
    nav: {
      features: 'Features',
      benefits: 'Benefits',
      pricing: 'Pricing',
      contact: 'Contact',
      faq: 'FAQ',
      signIn: 'Sign In',
      getStarted: 'Get Started',
      forBusiness: 'For Business'
    },
    // Landing Page
    landing: {
      nav: {
        features: 'Features',
        benefits: 'Benefits',
        pricing: 'Pricing',
        contact: 'Contact',
        faq: 'FAQ',
        signIn: 'Sign In',
        getStarted: 'Get Started',
        forBusiness: 'For Business'
      },
      hero: {
        badge: 'Powered by AI',
        title1: 'Transform Customers Into Brand Promoters',
        title2: 'and Multiply Your Prospects',
        subtitle: 'Launch powerful referral programs that drive growth, increase customer loyalty, and scale your business with our all-in-one platform.',
        startTrial: 'Start Free Trial',
        viewPricing: 'View Pricing',
        noCreditCard: 'No credit card required',
        freeTrial: '14-day free trial',
        cancelAnytime: 'Cancel anytime'
      },
      capabilities: {
        unlimited: 'Unlimited',
        scalability: 'Scalability',
        realtime: 'Real-time',
        processing: 'Processing',
        uptime: '99.9%',
        sla: 'Uptime SLA',
        enterprise: 'Enterprise',
        ready: 'Ready'
      },
      features: {
        title: 'Everything You Need to',
        titleHighlight: 'Succeed',
        subtitle: 'Powerful features designed to help you create, manage, and optimize your referral programs with ease.',
        referralManagement: {
          title: 'Referral Management',
          description: 'Complete system to manage and track all your referrals in real-time with detailed analytics.'
        },
        growthAnalytics: {
          title: 'Growth Analytics',
          description: 'Advanced analytics and insights to understand your referral program performance.'
        },
        rewardSystem: {
          title: 'Reward System',
          description: 'Flexible and customizable reward system to incentivize your customers.'
        },
        fraudPrevention: {
          title: 'Fraud Prevention',
          description: 'Advanced security measures to prevent fraud and ensure program integrity.'
        },
        instantAutomation: {
          title: 'Instant Automation',
          description: 'Automate referral tracking, rewards distribution, and notifications.'
        },
        realtimeReports: {
          title: 'Real-time Reports',
          description: 'Get instant reports and insights about your referral program performance.'
        }
      },
      benefits: {
        title: 'Why Choose',
        titleHighlight: 'Enrola',
        subtitle: 'Built with cutting-edge technology to power your business growth.',
        increaseSales: {
          title: 'Increase Sales',
          description: 'Boost your sales by up to 300% through strategic referral programs.',
          stat: '+300%'
        },
        customerGrowth: {
          title: 'Customer Growth',
          description: 'Acquire new customers at 5x lower cost than traditional marketing.',
          stat: '5x ROI'
        },
        customerLoyalty: {
          title: 'Customer Loyalty',
          description: 'Increase customer retention and lifetime value significantly.',
          stat: '+85%'
        },
        fastDeployment: {
          title: 'Fast Deployment',
          description: 'Get your referral program running in less than 24 hours.',
          stat: '< 24h'
        }
      },
      pricing: {
        title: 'Simple, Transparent',
        titleHighlight: 'Pricing',
        subtitle: 'Choose the perfect plan for your business. Scale as you grow.',
        trialNote: 'All plans include a 14-day free trial. No credit card required.',
        startTrial: 'Start Free Trial',
        startTrialShort: 'Start trial',
        contactSales: 'Contact Sales',
        contactSalesShort: 'Contact',
        perMonth: 'month',
        customPrice: 'Custom',
        plans: [
          {
            id: 'starter',
            name: 'Starter',
            price: '49',
            period: 'month',
            description: 'Perfect for small businesses starting with referrals',
            features: [
              'Up to 500 referrals/month',
              'Basic analytics dashboard',
              'Email notifications',
              'Standard reward system',
              'Email support',
              'API access',
            ],
            popular: false,
          },
          {
            id: 'professional',
            name: 'Professional',
            price: '149',
            period: 'month',
            description: 'For growing companies with advanced needs',
            features: [
              'Up to 5,000 referrals/month',
              'Advanced analytics & reports',
              'Multi-channel notifications',
              'Custom reward rules',
              'Priority support',
              'Advanced API & webhooks',
              'Custom branding',
              'Fraud detection',
            ],
            popular: true,
          },
          {
            id: 'enterprise',
            name: 'Enterprise',
            price: 'Custom',
            period: '',
            description: 'Tailored solutions for large organizations',
            features: [
              'Unlimited referrals',
              'White-label solution',
              'Dedicated account manager',
              'Custom integrations',
              '24/7 phone support',
              'Advanced security features',
              'Custom development',
              'SLA guarantee',
              'Multi-tenant support',
            ],
            popular: false,
          },
        ],
      },
      sceneNav: {
        sections: 'Page sections',
        hero: 'Home',
        capabilities: 'Overview',
        features: 'Features',
        benefits: 'Benefits',
        pricing: 'Pricing',
        contact: 'Contact',
        faq: 'FAQ',
        footer: 'Get started',
      },
      contact: {
        title: 'Contact &',
        titleHighlight: 'Support',
        subtitle: 'Get in touch with our team for support, questions, or partnership opportunities.',
        immediate: 'Need Immediate Assistance?',
        immediateDesc: 'Our support team is available 24/7 to help you with any questions or issues you may have.',
        contactSupport: 'Contact Support',
        salesInquiry: 'Sales Inquiry',
        methods: {
          support: {
            title: 'Email Support',
            description: 'Get help from our support team',
          },
          sales: {
            title: 'Sales Inquiries',
            description: 'Interested in our Enterprise plan?',
          },
          tech: {
            title: 'Technical Support',
            description: 'Need technical assistance?',
          },
        },
      },
      faq: {
        title: 'Frequently Asked',
        titleHighlight: 'Questions',
        subtitle: 'Everything you need to know about Enrola.',
        items: [
          {
            question: 'How quickly can I get started?',
            answer: 'You can set up your referral program in less than 15 minutes. Our intuitive dashboard makes it easy to configure rewards, customize branding, and start inviting customers.',
          },
          {
            question: 'What integrations do you support?',
            answer: 'We offer integrations with major CRM platforms, email marketing tools, payment processors, and e-commerce platforms. We also provide a robust API for custom integrations.',
          },
          {
            question: 'How do you prevent fraud?',
            answer: 'Our advanced fraud detection system uses machine learning to identify suspicious activities, duplicate accounts, and invalid referrals in real-time.',
          },
          {
            question: 'Can I customize the reward structure?',
            answer: 'Absolutely! You have complete flexibility to create custom reward tiers, set different rewards for referrers and referees, and implement time-limited campaigns.',
          },
          {
            question: 'Is there a contract or can I cancel anytime?',
            answer: 'All our plans are month-to-month with no long-term contracts. You can upgrade, downgrade, or cancel anytime without penalties.',
          },
          {
            question: 'Do you provide customer support?',
            answer: 'Yes! We offer email support for all plans, priority support for Professional plans, and 24/7 phone support for Enterprise customers.',
          },
        ],
      },
      cta: {
        title: 'Ready to Grow Your Business?',
        subtitle: 'Start building successful referral programs with our powerful, enterprise-ready platform.',
        startTrial: 'Start Your Free Trial',
        viewPricing: 'View Pricing',
        trialNote: 'No credit card required • 14-day free trial • Cancel anytime'
      },
      footer: {
        description: 'Enrola — the referral platform built to turn customers into brand promoters and scale your growth.',
        product: 'Product',
        company: 'Company',
        legal: 'Legal',
        security: 'Enterprise-grade security',
        copyright: '© 2025 Enrola. All rights reserved.',
        visitWebsite: 'Visit enrolanow.com',
        securityInfo: 'Security information',
        features: 'Features',
        pricing: 'Pricing',
        integrations: 'Integrations',
        api: 'API',
        aboutUs: 'About Us',
        blog: 'Blog',
        careers: 'Careers',
        contact: 'Contact',
        privacyPolicy: 'Privacy Policy',
        termsOfService: 'Terms of Service',
        securityLink: 'Security',
        gdpr: 'GDPR'
      }
    },
    legal: {
      pageTitle: 'Terms of Service and Privacy Policy',
      effectiveDate: 'Effective date',
      termsHeading: 'General Terms of Service',
      privacyHeading: 'Privacy Policy for the United States',
      backToHome: 'Back to home',
      backToRegistration: 'Back to registration',
      agreementPrefix: 'I have read and agree to the',
      termsLink: 'Terms of Service',
      agreementAnd: 'and the',
      privacyLink: 'Privacy Policy',
      mustAccept: 'You must accept the terms and privacy policy to continue',
    },
    // Login
    login: {
      welcome: 'Welcome to the',
      future: 'Future of Referrals',
      subtitle: 'Join thousands of successful referrers earning with our premium platform. Start your journey today and unlock unlimited earning potential.',
      welcomeBack: 'Welcome Back',
      signInAccount: 'Sign in to your account',
      email: 'Email',
      enterEmail: 'Enter your email address',
      password: 'Password',
      enterPassword: 'Enter your password',
      signIn: 'Sign In',
      backToHome: 'Back to home',
      forgotPassword: 'Forgot your password?',
      features: {
        launch: {
          title: 'Launch Your Success',
          desc: 'Start earning with our powerful referral system'
        },
        secure: {
          title: 'Secure & Trusted',
          desc: 'Enterprise-grade security for your peace of mind'
        },
        premium: {
          title: 'Premium Experience',
          desc: 'Enjoy our premium platform features and support'
        }
      },
      welcomeBackToast: 'Welcome back!',
      errorToast: 'An unexpected error occurred',
      signInFailed: 'Sign-in failed',
      businessPortalPrompt: 'Company administrator?',
    },
    // Forgot Password
    forgotPassword: {
      title: 'Recover your',
      titleHighlight: 'Password',
      subtitle: 'Enter your email address and we will send you a secure link to reset your password.',
      recoverPassword: 'Recover Password',
      sendLink: 'We will send you a secure link to your email',
      email: 'Email',
      enterEmail: 'Enter your email address',
      sendRecoveryLink: 'Send Recovery Link',
      backToLogin: '← Back to Sign In',
      features: {
        secure: {
          title: 'Secure Recovery',
          desc: 'Secure password recovery system'
        },
        protection: {
          title: 'Account Protection',
          desc: 'Your information is protected at all times'
        },
        support: {
          title: 'Quick Support',
          desc: 'Recover access to your account quickly'
        }
      },
      successMessage: 'If the email exists, a recovery link has been sent',
      errorMessage: 'Error processing request',
      connectionError: 'Connection error',
      recoveryLinkSent: 'Recovery link sent',
      couldNotProcess: 'Could not process your request',
    },
    // Reset Password
    resetPassword: {
      new: 'New',
      titleHighlight: 'Password',
      subtitle: 'Create a secure new password to protect your account.',
      createNewPassword: 'Create New Password',
      chooseSecure: 'Choose a secure password for your account',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      enterNewPassword: 'Enter your new password',
      confirmNewPassword: 'Confirm your new password',
      updatePassword: 'Update Password',
      backToLogin: '← Back to Sign In',
      passwordStrength: 'Password strength:',
      weak: 'Weak',
      medium: 'Medium',
      strong: 'Strong',
      passwordsMatch: 'Passwords match',
      passwordsNoMatch: 'Passwords do not match',
      features: {
        security: {
          title: 'Maximum Security',
          desc: 'Your new password is protected with encryption'
        },
        instant: {
          title: 'Instant Access',
          desc: 'You can access your account immediately'
        },
        continuity: {
          title: 'Guaranteed Continuity',
          desc: 'Resume your activities without interruptions'
        }
      },
      invalidLink: 'Invalid Link',
      invalidLinkDesc: 'The recovery link is invalid or has expired.',
      requestNewLink: 'Request New Link',
      passwordMismatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 6 characters',
      passwordUpdated: 'Password updated successfully',
      resetError: 'Error resetting password',
      connectionError: 'Connection error',
    },
    errorBoundary: {
      title: 'Application error',
      message: 'Something went wrong. Please reload the page.',
      details: 'Error details (development only)',
      reload: 'Reload page'
    },
    // Common
    brand: {
      productName: 'Enrola',
      byline: 'by Elantar',
      fullName: 'Enrola by Elantar',
      logoAlt: 'Enrola by Elantar logo',
      edition: 'Referral & rewards platform',
    },
    common: {
      loading: 'Loading...',
      saving: 'Saving...',
      cancel: 'Cancel',
      confirm: 'Confirm',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      update: 'Update',
      close: 'Close',
      backToTop: 'Back to top',
      ptsShort: 'pts',
      currencyUsd: 'USD',
      keyMetrics: 'Key metrics',
      willBeChanged: 'Will be changed',
      search: 'Search',
      searchPlaceholder: 'Search...',
      clearSearch: 'Clear search',
      noResults: 'No results found',
      error: 'Error',
      success: 'Success',
      yes: 'Yes',
      no: 'No',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      actions: 'Actions',
      status: 'Status',
      date: 'Date',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      sessionWelcome: 'Welcome back, {name}!',
      sessionWelcomeFallback: 'Welcome back!',
      phoneCopied: 'Phone number copied to clipboard!',
      copyPhone: 'Tap to copy phone number',
      copyFailed: 'Could not copy',
      username: 'Username',
      password: 'Password',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      user: 'User',
      admin: 'Admin',
      member: 'Member',
      administrator: 'Administrator',
      vendor: 'Representative',
      trendingUp: 'Trending up',
      trendingDown: 'Trending down',
      noActivity: 'No activity',
      daysShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      languageSwitcher: 'Change language',
      skipToContent: 'Skip to content',
      expandSidebar: 'Expand sidebar',
      collapseSidebar: 'Collapse sidebar',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      tabs: 'Tabs',
      confirmTitle: 'Confirm action',
      confirmDestructiveTitle: 'Confirm deletion',
      loadingContent: 'Loading content',
      loadingDashboard: 'Loading dashboard',
      table: {
        searchPlaceholder: 'Search table...',
        filterAll: 'All',
        clearFilters: 'Clear filters',
        showingResults: 'Showing {count} of {total}',
        noMatchingRows: 'No matching rows',
        filterByStatus: 'Status',
        filterByVendor: 'Representative',
        filterByEvent: 'Event',
        filterReady: 'Ready',
        filterErrors: 'With errors',
      },
      stateDistribution: {
        dateRange: 'Date range',
        dateFrom: 'From',
        dateTo: 'To',
        allDates: 'All dates',
        apply: 'Apply',
        vendor: 'Representative',
        allVendors: 'All representatives',
        clearFilters: 'Clear filters',
        historicalMode: 'Historical',
        historicalModeHint: 'Show cumulative counts for each stage reached over time',
        historicalModeActiveHint: 'Historical mode active — counting every stage transition',
        loading: 'Loading distribution data...',
        exportPdf: 'Export PDF',
        exportExcel: 'Export Excel',
        exportSuccess: 'Export completed',
        exportFailed: 'Export failed',
        noData: 'No data to export',
        state: 'State',
        count: 'Count',
        percentage: 'Percentage',
        chart: 'Chart',
        sheetName: 'Distribution',
        reportSubtitle: 'State distribution report',
        printedOn: 'Printed on',
        printedBy: 'Printed by',
        appliedFilters: 'Applied filters',
        noFiltersApplied: 'No filters applied',
        summary: 'Summary',
        totalRecords: 'Total records',
        chartOverview: 'Chart overview',
        detailedData: 'Detailed data',
        noDetailRecords: 'No records match the selected filters.',
        clientName: 'Client',
        email: 'Email',
        phone: 'Phone',
        referrals: 'Referrals',
        createdAt: 'Created',
        stateUpdatedAt: 'State updated',
        representatives: 'Representatives',
        prospectName: 'Prospect',
        address: 'Address',
        status: 'Status',
        saleType: 'Sale type',
        updatedAt: 'Updated',
        representative: 'Representative',
        detailSheetName: 'Detail',
        summarySheetName: 'Summary',
        filterByVendorButton: 'Filter by representative',
        vendorFilterModalTitle: 'Select representative',
        vendorFilterAllTitle: 'All representatives',
        vendorFilterAllDesc: 'View metrics for the entire platform',
        vendorFilterClients: 'Clients',
        vendorFilterReferrals: 'Referrals',
        vendorFilterProspects: 'Prospects',
        vendorFilterMemberSince: 'Since {date}',
        vendorFilterSelected: 'Selected',
        vendorFilterNoVendors: 'No representatives registered',
      },
    },
    ux: {
      nextBestAction: {
        greeting: 'Hey, {name}',
        clientInvite: {
          title: 'Invite your first contact',
          description: 'Share your referral link or QR code to start earning points.',
          cta: 'Open invite tools',
          motivations: [
            'A friend away from more rewards — share your link.',
            'One invite today can unlock your next gift.',
            'Scan, share, smile. Your network grows with you.',
          ],
        },
        clientInviteMore: {
          title: 'Grow your network today',
          description: 'Send your link to someone who would benefit from the program.',
          cta: 'Share referral link',
          motivations: [
            'A friend away from more rewards — share your link.',
            'One invite today can unlock your next gift.',
            'You’re building something great — stay curious.',
          ],
        },
        clientClaim: {
          title: 'You can redeem a reward now',
          description: 'Use your points before they expire — delivery is tracked in your account.',
          cta: 'Claim reward',
          motivations: [
            'Your points are working for you — claim that reward!',
            'That gift is yours. Go ahead and redeem it.',
            'You’ve earned it. Time to claim your reward.',
          ],
        },
        clientTrackGift: {
          title: 'A gift is on the way',
          description: 'Follow delivery status and confirm receipt when it arrives.',
          cta: 'Track my gift',
          motivations: [
            'Your gift is moving — check where it is now.',
            'Almost there! Track your delivery and get ready to smile.',
            'Something good is on the way. Peek at the status.',
          ],
        },
        clientBrowse: {
          title: 'Browse the rewards catalog',
          description: 'See what you can earn next and how many points each gift needs.',
          cta: 'View rewards',
          motivations: [
            'Your points are working for you. Keep going!',
            'Curious what you can unlock next? Peek at the catalog.',
            'You’re building something great — stay curious.',
          ],
        },
        clientMission: {
          title: 'Complete your daily mission',
          description: 'Small consistent steps grow your network faster than sporadic bursts.',
          cta: 'Do it now',
          motivations: [
            'One quick win today keeps the momentum going.',
            'Small steps, big network — finish today’s mission.',
            'You’ve got this. Knock out that mission.',
          ],
        },
        vendorProspect: {
          title: 'Create a new prospect',
          description: 'Add a lead, track follow-ups, and enroll them when they are ready.',
          cta: 'New prospect',
          motivations: [
            'Ready to enroll that client?',
            'One more prospect today changes the whole week.',
            'Smile, call, enroll. Let’s make it a strong day.',
            'Your pipeline is waiting — make the next move count.',
          ],
        },
        vendorGifts: {
          title: 'Gifts waiting for delivery',
          description: 'Clients are expecting their rewards — mark deliveries to keep trust high.',
          cta: 'Review pending gifts',
          motivations: [
            'Clients are waiting on their gifts — keep the trust high.',
            'Deliveries pending. Let’s get those rewards moving.',
            'A quick delivery update makes someone’s day.',
          ],
        },
        vendorMission: {
          title: 'Complete your daily mission',
          description: 'Small consistent steps grow your pipeline faster than sporadic bursts.',
          cta: 'Do it now',
          motivations: [
            'Today we hit that sales goal — you’ve got this.',
            'Your pipeline is waiting — make the next move count.',
            'Small steps today, stronger pipeline tomorrow.',
          ],
        },
        adminGifts: {
          title: 'Review pending gift handoffs',
          description: 'Claims need admin approval before representatives can deliver to clients.',
          cta: 'Open pending gifts',
          motivations: [
            'Keep the pipeline healthy and the gifts moving.',
            'A quick gift review now keeps the whole program sharp.',
            'Handoffs waiting — clear them and keep momentum.',
          ],
        },
        adminNotifications: {
          title: 'Unread notifications need attention',
          description: 'Catch up on program events before they turn into delays.',
          cta: 'Open notifications',
          motivations: [
            'A quick review now keeps the whole program sharp.',
            'Your team is counting on clear direction today.',
            'Catch up fast — small ops wins compound.',
          ],
        },
        adminPipeline: {
          title: 'Review your user pipeline',
          description: 'Check representatives, clients, and stage distribution for bottlenecks.',
          cta: 'Manage users',
          motivations: [
            'Lead with clarity. Your representatives will follow.',
            'Your team is counting on clear direction today.',
            'Small ops wins compound — you’ve got the dashboard.',
          ],
        },
      },
      actionOutcome: {
        dismiss: 'Got it',
        undo: 'Undo',
        nextStepLabel: 'Next:',
        giftAdminDelivered: {
          title: 'Gift handed off to representative',
          description: 'The claim moved to the representative queue for client delivery.',
          nextStep: 'The representative will mark delivery when the client receives the gift.',
        },
        giftVendorDelivered: {
          title: 'Gift marked as delivered',
          description: 'The client can now confirm receipt and leave a review.',
          nextStep: 'You will be notified when the client confirms receipt.',
        },
        giftConfirmed: {
          title: 'Receipt confirmed — thank you!',
          description: 'Your review helps representatives improve and unlocks your reward history.',
          nextStep: 'Browse more rewards or invite friends to earn additional points.',
        },
        rewardClaimed: {
          title: 'Reward claimed successfully',
          description: 'Your gift request was submitted and points were deducted.',
          nextStep: 'Track preparation and delivery under Gifts in transit.',
        },
        clientAdvanced: {
          title: 'Client stage updated',
          description: 'The pipeline reflects the new status immediately.',
          nextStep: 'Follow up with the client or advance again when the next milestone is reached.',
        },
        prospectEnrolled: {
          title: 'Prospect enrolled as client',
          description: 'They were removed from the prospect list and added to your client roster.',
          nextStep: 'Share referral tools or schedule the first follow-up from My clients.',
        },
      },
      viewState: {
        retry: 'Try again',
        loadFailed: 'Could not load this section',
      },
      validation: {
        emailRequired: 'Email is required',
        emailInvalid: 'Enter a valid email address',
        passwordRequired: 'Password is required',
        passwordMin: 'Password must be at least 6 characters',
        passwordMismatch: 'Passwords do not match',
        fieldRequired: 'This field is required',
        companyRequired: 'Company name is required',
        termsRequired: 'Please accept the terms to continue',
        ratingsRequired: 'Please rate both the product and your representative',
        rewardNameRequired: 'Reward name is required',
        pointsRequired: 'Points value is required',
      },
      onboarding: {
        exploreFirst: 'Explore dashboard first',
        exploreHint: 'You can complete reward selection anytime from the rewards tab.',
      },
    },
    notFound: {
      title: 'Page not found',
      description: 'The page you are looking for does not exist or has moved.',
      home: 'Go home',
      dashboard: 'Go to dashboard',
    },
    apiErrors: {
      emailAndPasswordRequired: 'Email and password are required',
      invalidEmail: 'Invalid email address',
      invalidCredentials: 'Invalid credentials',
      adminUseEnterprisePortal: 'Company administrators must sign in through the business portal',
      companyNotFound: 'Company not found',
      companyFieldsRequired: 'Company name, email, and password are required',
      passwordTooShort: 'Password must be at least 6 characters',
      emailAlreadyRegistered: 'Email is already registered',
      registrationFailed: 'Registration failed',
      missingRequiredFields: 'Missing required fields',
      companyContextRequired: 'Company context required. Use a referral link or provide company slug.',
      usernameAlreadyExists: 'Username already exists',
      emailAlreadyExists: 'Email already exists',
      dateOfBirthRequired: 'Date of birth is required',
      invalidDateOfBirth: 'Invalid date of birth',
      dateOfBirthMustBePast: 'Date of birth must be in the past',
      minRegistrationAge: 'You must be at least {minAge} years old to register',
      vendorAccessRequired: 'Representative access required',
      vendorNotFound: 'Representative not found',
      prospectNotFound: 'Prospect not found',
      prospectEmailRequiredForEnroll: 'Prospect must have an email to enroll as a client',
      clientEmailAlreadyExists: 'A client with this email already exists',
      prospectNameRequired: 'Name is required',
      invalidProspectStatus: 'Invalid status: {status}',
      prospectionLevelRange: 'Prospection level must be between 0 and 5',
      prospectionLevelInvalid: 'Prospection level must be a number between 0 and 5',
      invalidBooleanValue: 'Invalid boolean value',
      invalidHousingType: 'Housing type must be OWN or RENT',
      appointmentTimesRequired: 'Start time and end time are required',
      appointmentEndAfterStart: 'End time must be after start time',
      invalidTimeFormat: 'Time must use HH:MM format',
      invalidTimeValue: 'Invalid time value',
      notAuthenticated: 'Not authenticated',
      tooManyRequests: 'Too many requests. Please try again later.',
      crossOriginRequestBlocked: 'Cross-origin request blocked',
      adminAccessRequired: 'Admin access required',
      companyContextRequiredShort: 'Company context required',
      signInFailed: 'Sign-in failed',
      registrationFailedGeneric: 'Registration failed',
      companyRegistrationFailed: 'Company registration failed',
      companySignInFailed: 'Company sign-in failed',
      cannotReachServer: 'Cannot reach server. Is the backend running?',
      validationError: 'Validation error',
      addressSearchUnavailable: 'Address search unavailable',
      emailRequired: 'Email is required',
      passwordRequired: 'Password is required',
      invalidOrExpiredResetLink: 'Invalid or expired reset link',
      noDataProvided: 'No data provided',
      nameCannotBeEmpty: 'Name cannot be empty',
      currentPasswordRequired: 'Current password is required',
      currentPasswordIncorrect: 'Current password is incorrect',
      excelFileRequired: 'Excel file is required',
      couldNotReadSpreadsheet: 'Could not read spreadsheet',
      emptySpreadsheet: 'Empty spreadsheet',
      missingNameColumn: 'Missing "name" column in first row',
      videoNotFound: 'Video not found',
      videoSaveFailed: 'Failed to save video',
      titleRequired: 'Title is required',
      titleTooLong: 'Title is too long',
      videoAudienceRequired: 'Select at least one audience: clients or representatives',
      videoUrlRequired: 'A video URL is required',
      videoFileRequired: 'A video file is required',
      invalidVideoSource: 'Source type must be url or file',
      invalidSortOrder: 'Sort order must be a number',
      invalidVideoUrl: 'Invalid video URL',
      userNotFound: 'User not found',
      featureNotAvailableForCompany: 'This feature is not available for your company',
      nameTooLong: 'Name is too long',
      platformAdminAccessRequired: 'Platform super administrator access required',
      backupFileRequired: 'Select a backup file to restore',
      backupFormatUnsupported: 'This file is not a supported backup',
      backupInvalid: 'The backup file is invalid or corrupted',
      backupConfirmationRequired: 'Type RESTORE to confirm the restore',
      backupRestoreFailed: 'The backup could not be restored',
      backupBuildFailed: 'The backup could not be generated',
      backupInfoFailed: 'Could not read the backup inventory',
      promotionNotFound: 'Promotion not found',
      promotionTitleRequired: 'Promotion title is required',
      promotionPrizeRequired: 'Prize name is required',
      promotionInvalidRequired: 'Required referrals must be a whole number of at least 1',
      promotionInvalidMinState: 'Invalid minimum referral state',
      promotionInvalidPrizeType: 'Prize type must be physical or cash',
      promotionCycleNotFound: 'Promotion cycle not found',
      promotionCycleLocked: 'This cycle already has tickets and cannot be changed or deleted',
      promotionInvalidDates: 'Start, end and draw dates are required and must be chronological',
      promotionAlreadyDrawn: 'This cycle has already been drawn',
      promotionWinnerNotFound: 'Winner client not found',
      promotionReasonRequired: 'A reason is required for a manual winner change',
      promotionDeleteBlocked: 'Promotions with issued tickets cannot be deleted',
      promotionExclusiveClientNotFound: 'Exclusive client not found in this company',
      invalidVendor: 'Invalid representative',
      companyNotFoundShort: 'Company not found',
      platformAdminRequired: 'Platform super administrator access required',
    },
    statsCard: {
      vsLastPeriod: 'vs last period',
      last7Days: 'Last 7 days',
      periodToggleLabel: 'Analytics period',
      periods: {
        weekly: 'Weekly',
        monthly: 'Monthly',
        yearly: 'Yearly',
        all: 'All time',
      },
      trendWeekly: 'Last 7 days',
      trendMonthly: 'This month',
      trendYearly: 'This year',
      trendAll: 'Last 12 months',
    },
    analytics: {
      platformActivity: 'Platform Activity (Last 7 Days)',
      chartNewUsers: 'New Users',
      chartReferrals: 'Referrals',
      chartClicks: 'Clicks',
      chartConversions: 'Conversions',
      clientsCount: '{count} clients',
      pointsCount: '{count} points',
      referralsShort: 'referrals',
      performanceTrends: 'Performance Trends (Last 7 Days)',
      clientProgressStates: 'Client Progress States',
      thisMonthPerformance: 'This Month Performance',
      topPerformingClient: 'Top Performing Client',
      successfulReferrals: '{count} successful referrals',
      noClientData: 'No client data available yet',
      clicksConversions: 'Clicks & Conversions (Last 7 Days)',
      outOfTotalLinks: 'Out of {total} total links',
      totalSuccessfulReferrals: 'Total successful referrals',
      earnPointsMilestone: 'Earn points with each referral milestone',
      eyebrow: 'Insights',
    },
    // Dashboard
    dashboard: {
      title: 'Dashboard',
      subtitle: 'Overview of your activity',
      loading: 'Loading your dashboard...',
      rewardPoints: 'Reward Points',
      conversions: 'Conversions',
      lifetimePoints: 'Lifetime Points',
      last7Days: 'Last 7 days',
      referrals: 'Referrals',
      analytics: 'Analytics',
      network: 'Network',
      rewards: 'Rewards',
      activeLinks: 'Active Links',
      totalClicks: 'Total Clicks',
      yourEarnedRewardPoints: 'Your earned reward points',
      successfulReferralConversions: 'Successful referral conversions',
      viewRewardPoints: 'View your reward points and available rewards',
      trackEarnedPoints: 'Track how you have earned your reward points',
      startReferringClients: 'Start referring clients to earn reward points!',
      conversionsToGo: 'conversions to go',
      welcomeBack: 'Welcome back, {name}!',
      crushingIt: 'You\'re crushing it! Your referral program is performing excellently.',
      proMember: 'Pro Member',
      loadingDashboard: 'Loading your dashboard...',
      failedToLoadAnalytics: 'Failed to load analytics data',
      failedToLoadNetwork: 'Failed to load network data',
      nextMilestone: 'Next Milestone',
      growthRate: 'Growth Rate',
      newClicks: 'New Clicks',
      pointsHistory: 'Points History',
      noPointsHistoryYet: 'No points history yet',
      searchPointsHistory: 'Search by client or date...',
      filterByEventState: 'Filter by event',
      noMatchingPointsHistory: 'No records match your search or filters.',
      date: 'Date',
      event: 'Event',
      referredClient: 'Referred Client',
      pointsEarned: 'Points Earned',
      joined: 'Joined',
      trackPerformance: 'Track your performance and growth metrics',
      manageReferralLinks: 'Manage and monitor your referral links',
      referralNetwork: 'Your referral network and connections',
      stayUpdated: 'Stay updated with the latest activities',
      customizeAccount: 'Customize your account and preferences',
      performanceOverview: 'Welcome back, {name}! Here\'s your performance overview.',
      vsLastPeriod: 'vs last period',
      recentReferralLinks: 'Recent Referral Links',
      noReferralLinks: 'No referral links yet',
      createFirstLink: 'Create your first referral link to start earning commissions.',
      createLink: 'Create Link',
      quickActions: 'Quick Actions',
      viewAnalytics: 'View Analytics',
      manageReferrals: 'Manage Referrals',
      viewNetwork: 'View Network',
      referralLinks: 'Referral Links',
      manageTrack: 'Manage and track all your referral links',
      yourNetwork: 'Your Network',
      peopleReferred: 'People you have referred to the platform',
      networkStats: 'Network Stats',
      totalReferred: 'Total Referred',
      activeMembers: 'Active Members',
      totalReferralsMade: 'Total Referrals Made',
      networkMembers: 'Network Members',
      loadingRewards: 'Loading rewards...',
      currentPoints: 'Current Points',
      yourReferrals: 'Your Referrals',
      nextReward: 'Next Reward',
      availableRewards: 'Available Rewards',
      welcomeRewardsTitle: 'Welcome gifts',
      welcomeRewardsSubtitle: 'Choose any of these three gifts when you redeem your welcome bonus — same point cost.',
      catalogRewardsTitle: 'Catalog',
      catalogRewardsSubtitle: 'Earn more points by referring friends and unlock these products.',
      noPointsHistory: 'No points history yet',
      noRewardsAvailable: 'No rewards available at the moment',
      failedToLoadRewards: 'Failed to load rewards data',
      errorLoadingReferralLinks: 'Error loading referral links',
      rewardClaimed: 'Reward claimed!',
      thisWeekPerformance: 'This Week\'s Performance',
      redeemSubtitle: 'Redeem your points for amazing rewards',
      available: 'Available',
      noDescription: 'No description available',
      points: 'points',
      moreNeeded: '{count} more needed',
      checkBackLater: 'Check back later for exciting rewards!',
      settings: 'Settings',
      notifications: 'Notifications',
      linkCreated: 'Referral link created successfully!',
      errorCreatingLink: 'Error creating referral link',
      createNewLink: 'Create New Link',
      createFirstLinkBtn: 'Create Your First Link',
      claimReward: 'Claim reward',
      giftOnTheWay: 'Your gift is on the way',
      claimFailed: 'Could not claim reward',
      viewReward: 'View reward',
      claimConfirmTitle: 'Claim this reward?',
      claimConfirmMessage: 'You are about to redeem {name} for {points} points. They will be deducted from your balance and the gift will be on its way.',
      claimConfirmAction: 'Yes, claim it',
      historicalTotal: 'Historical total:',
      percentComplete: '{percent}% complete',
      noMoreGoals: 'No more goals configured',
      creating: 'Creating...',
      totalLabel: 'Total',
      activeLabel: 'Active',
      completedLabel: 'Completed',
      noMoreGoalsReached: 'No more goals or you have reached them all',
    },
    pendingGifts: {
      title: 'Pending gifts',
      adminSubtitle: 'Hand rewards to representatives and track client deliveries.',
      vendorSubtitle: 'Deliver claimed rewards to your referred clients.',
      awaitingHandoff: 'Awaiting handoff to representative',
      withVendor: 'With representative — pending client delivery',
      readyToDeliver: 'Ready to deliver to client',
      recentlyCompleted: 'Recently completed',
      claimedByLine: 'Claimed by {name}',
      pointsLabel: 'pts spent',
      noVendorAssigned: 'No representative assigned',
      markDeliveredToVendor: 'Mark delivered to representative',
      markDeliveredToClient: 'Mark delivered to client',
      completed: 'Delivered',
      processing: 'Processing…',
      adminDeliveredSuccess: 'Gift marked as delivered to representative',
      vendorDeliveredSuccess: 'Gift marked as delivered to client',
      actionFailed: 'Could not update gift status',
      confirmAdminDeliverTitle: 'Hand gift to representative?',
      confirmAdminDeliverMessage: 'The representative will be responsible for delivering this reward to the client. This action cannot be undone from this screen.',
      confirmVendorDeliverTitle: 'Mark gift as delivered?',
      confirmVendorDeliverMessage: 'The client will be asked to confirm receipt and leave a review. Make sure the gift was actually delivered.',
      failedToLoad: 'Failed to load pending gifts',
      noAwaitingHandoff: 'No gifts waiting for handoff',
      noAwaitingHandoffDesc: 'New client claims will appear here.',
      noPendingGifts: 'No gifts to deliver',
      noPendingGiftsDesc: 'When admin hands you a gift, it will show up here.',
      awaitingAdminHandoff: 'Waiting for company handoff',
      awaitingAdminHandoffDesc: 'Your client claimed a reward. The company admin will prepare it for you.',
      waitingForAdminBadge: 'Waiting for admin',
      awaitingClientConfirmation: 'Delivered — awaiting client confirmation',
      awaitingClientConfirmationDesc: 'You marked these gifts as delivered. The client must confirm receipt.',
      awaitingClientBadge: 'Awaiting confirmation',
      vendorDaysRemaining: 'You have {days} day(s) left to deliver this gift',
      vendorFutureDeadline: 'Once you receive this gift, you will have {days} day(s) to deliver it to the client',
      vendorOverdueWarning: 'Delivery delay — overdue warning (day {day})',
      vendorPastDeadline: 'Delivery deadline has passed — please deliver as soon as possible',
    },
    giftsInTransit: {
      title: 'Gifts in transit',
      subtitle: 'Track your rewards and confirm when you receive them.',
      onTheWaySection: 'On the way',
      deliveredSection: 'Delivered by your representative',
      deliveredSectionDesc: 'Your representative marked the gift as delivered. Confirm receipt and leave a quick review.',
      preparingBadge: 'Preparing your gift',
      onTheWayBadge: 'On the way with your representative',
      deliveredByVendorBadge: 'Delivered by representative',
      confirmReceipt: 'Confirm receipt',
      confirmSuccess: 'Thanks! Your receipt was confirmed.',
      confirmFailed: 'Could not confirm receipt',
      failedToLoad: 'Failed to load your gifts',
      emptyTitle: 'No gifts to track',
      emptyDesc: 'When you redeem a reward and admin hands it to your representative, it will appear here.',
      noOnTheWay: 'No gifts on the way right now.',
      noDelivered: 'No gifts awaiting your confirmation.',
      noVendor: 'No representative assigned',
      pointsLabel: 'pts',
      processing: 'Processing…',
      reviewModalTitle: 'How was your experience with {name}?',
      reviewModalDesc: 'Rate the product and your experience with the representative. It only takes a moment.',
      productRatingLabel: 'Product rating',
      vendorRatingLabel: 'Representative experience',
      reviewTextLabel: 'Comment (optional)',
      reviewTextPlaceholder: 'Tell us briefly about your experience…',
      ratingsRequired: 'Please rate both the product and the representative',
      submitReview: 'Confirm and submit review',
      cancel: 'Cancel',
      clientDeliveryPromise: 'You will receive your gift in less than {days} day(s)',
    },
    myContacts: {
      title: 'My contacts',
      subtitle: 'Connect Google Contacts and invite people by SMS with your referral link.',
      importFromGoogle: 'Import from Google',
      selectFromPhone: 'Import from Google',
      importing: 'Connecting to Google…',
      importSuccess: '{created} contact(s) added, {updated} updated',
      importFailed: 'Could not save contacts',
      importEmpty: 'No contacts with a phone number were found',
      googleImportHint: 'You will sign in with Google and grant Enrola read-only access to your contacts. Only contacts with a phone number are imported.',
      googleImportSuccess: 'Google contacts imported: {created} added, {updated} updated',
      googleImportFailed: 'Could not import contacts from Google',
      googleImportCancelled: 'Google authorization was cancelled',
      googleImportNoPhoneContacts: 'No Google contacts with a phone number were found',
      googleNotConfigured: 'Google Contacts import is not configured yet. Ask your administrator to set GOOGLE_CLIENT_ID and GOOGLE_CLIENT_SECRET.',
      androidImportHint: 'Android detected: import from Google or pick contacts directly from your phone.',
      iosImportHint: 'iPhone detected: import from Google, or bring contacts from the iPhone Contacts app via contact card (.vcf).',
      desktopImportHint: 'Import your contacts from Google. Works on any browser.',
      importFromPhone: 'Choose from phone',
      importFromICloud: 'Import from iPhone Contacts',
      importingPhone: 'Opening contacts…',
      importingVCard: 'Reading contact card…',
      phonePickerUnsupported: 'Your browser cannot open the phone contact list. Use Google import instead.',
      vcardFailed: 'Could not read the contact card file',
      iosVCardSteps: 'In Contacts: open a person → Share → tap the contact card (.vcf) → choose Enrola or save to Files and upload here. Repeat for each contact you want to add.',
      secureTitle: 'Stored securely on the platform',
      secureDesc: 'Your contact list is saved in your account and is only visible to you. Google access is used once to import your contacts.',
      totalContacts: 'Total contacts',
      invitedContacts: 'Invited',
      pendingInvites: 'Not invited yet',
      searchPlaceholder: 'Search by name, phone or email…',
      emptyTitle: 'No contacts yet',
      emptyDesc: 'Connect your Google account to import contacts and invite them in one tap.',
      emptyDescDesktop: 'Import contacts from Google, then manage and invite them from any device.',
      columnName: 'Name',
      columnPhone: 'Phone',
      columnEmail: 'Email',
      columnStatus: 'Status',
      columnActions: 'Actions',
      statusInvited: 'Invited',
      statusPending: 'Pending',
      inviteSms: 'Invite via SMS',
      inviting: 'Opening SMS…',
      inviteOpened: 'SMS opened — send the message when ready',
      inviteFailed: 'Could not open SMS for this contact',
      invalidPhone: 'This contact has no valid phone number',
      noInviteLink: 'Your referral link is not ready yet',
      desktopCopied: 'Phone and message copied — send the SMS from your phone',
      removeContact: 'Remove contact',
      confirmDelete: 'Remove contact "{name}" from your list?',
      deletedSuccess: 'Contact removed',
      deleteFailed: 'Could not remove contact',
      failedToLoad: 'Failed to load your contacts',
    },
    vendorReviews: {
      title: 'Representative reviews',
      subtitle: 'Client feedback on delivered gifts and their experience with each representative.',
      deliveredBy: 'Delivered by',
      receivedBy: 'Received by',
      confirmedOn: 'Confirmed on',
      productRating: 'Product',
      vendorRating: 'Representative',
      noComment: 'No written comment',
      emptyTitle: 'No reviews yet',
      emptyDesc: 'When clients confirm gift receipt, their reviews will appear here.',
      failedToLoad: 'Failed to load reviews',
    },
    platformAdmin: {
      superAdminBadge: 'Super Admin',
      adminFallback: 'Admin',
      welcome: 'Welcome, {name}',
      homeSubtitle: 'Full visibility and control over every company, user, sale, and configuration in the platform.',
      viewCompanies: 'View companies',
      viewAnalytics: 'View sales analytics',
      openSettings: 'Open settings hub',
      totalCompanies: 'Companies',
      activeTenants: 'Active tenants on the platform',
      totalUsers: 'Total users',
      totalClients: 'Total clients',
      totalReferrals: 'Total referrals',
      acrossAllCompanies: 'Across all companies',
      platformRevenue: 'Platform revenue',
      estimatedRevenue: 'Estimated from referrals',
      companiesOverview: 'Companies overview',
      viewAll: 'View all',
      noCompanies: 'No companies registered yet',
      noCompaniesDesc: 'Companies will appear here once they register on the platform.',
      systemPulse: 'System pulse',
      totalProspects: 'Total prospects',
      pendingGifts: 'Pending gifts',
      companyAdmins: 'Company admins',
      manageAllSettings: 'Manage all settings',
      clientsShort: 'clients',
      vendorsShort: 'vendors',
      referralsShort: 'referrals',
      prospectsShort: 'prospects',
      sidebarCompanies: 'Companies',
      sidebarClients: 'Clients',
      sidebarSales: 'Sales',
      dashboardTitle: 'Platform control center',
      dashboardSubtitle: 'Monitor everything happening across the entire system.',
      companiesTitle: 'Companies',
      companiesSubtitle: 'Manage and inspect every tenant on the platform.',
      usersTitle: 'All users',
      usersSubtitle: 'Browse admins, representatives, and clients across companies.',
      clientsTitle: 'All clients',
      clientsSubtitle: 'View every client account registered in the system.',
      analyticsTitle: 'Sales & analytics',
      analyticsSubtitle: 'Platform-wide performance, revenue, and referral metrics.',
      settingsTitle: 'Platform settings',
      settingsSubtitle: 'Configure accounts, companies, rewards, pipeline, and system defaults.',
      prospectsTitle: 'All prospects',
      prospectsSubtitle: 'Pipeline activity across every company.',
      rewardsTitle: 'Rewards catalog',
      rewardsSubtitle: 'Manage reward programs per company.',
      pendingGiftsTitle: 'Pending gifts',
      pendingGiftsSubtitle: 'Track gift claims waiting for fulfillment.',
      vendorReviewsTitle: 'Representative reviews',
      vendorReviewsSubtitle: 'Client feedback across the entire platform.',
      videoHubTitle: 'Video Hub',
      videoHubSubtitle: 'Choose a company to manage the videos its members and representatives can watch.',
      failedToLoadOverview: 'Failed to load platform overview',
      overviewLoadError: 'Could not load platform data. Check your connection and try again.',
      retry: 'Try again',
      viewPendingGifts: 'Review pending gifts',
      notificationsComingSoon: 'Notification preferences are coming soon',
      notificationsComingSoonDesc: 'Platform-wide notification controls will be available in a future update. Use the notifications center in the top bar for now.',
      noRecentClients: 'No clients registered for this company yet',
      searchCompanies: 'Search companies...',
      searchUsers: 'Search users by name, email, company, or phone...',
      allCompanies: 'All companies',
      company: 'Company',
      admins: 'Admins',
      actions: 'Actions',
      configure: 'Configure',
      platformLevel: 'Platform',
      settingsHub: 'Settings hub',
      companiesSettings: 'Companies',
      companiesSettingsDesc: 'Review tenant health and jump into company-specific configuration.',
      rewardsSettings: 'Rewards & points',
      rewardsSettingsDesc: 'Edit point rules, catalog items, delivery windows, and short actions.',
      pipelineSettings: 'Pipeline & statuses',
      pipelineSettingsDesc: 'Manage prospect pipeline statuses for each company.',
      operationsSettings: 'Operations',
      operationsSettingsDesc: 'Overview of operational areas you can monitor from the platform menu.',
      operationsImports: 'User imports',
      operationsImportsDesc: 'Import representatives and clients per company from the company admin portal.',
      operationsGifts: 'Gift fulfillment',
      operationsGiftsDesc: 'Track pending gifts and delivery handoffs globally.',
      operationsReviews: 'Representative reviews',
      operationsReviewsDesc: 'Audit client satisfaction after gift delivery.',
      operationsAnalytics: 'Sales analytics',
      operationsAnalyticsDesc: 'Review revenue, referrals, and conversion trends platform-wide.',
      platformDefaults: 'Platform defaults',
      platformDefaultsDesc: 'Global controls reserved for the super administrator.',
      globalControlCenter: 'Global control center',
      globalControlCenterDesc: 'Use the sidebar to inspect companies, users, sales, prospects, rewards, and fulfillment across the entire platform.',
      accountSettingsDesc: 'Update your super-admin account credentials.',
      profileSettingsDesc: 'Your platform administrator identity.',
      selectCompanyContext: 'Select company to configure',
      chooseCompany: 'Choose a company...',
      companyContextHint: 'Company-scoped settings apply only to the selected tenant.',
      pickCompanyFirst: 'Select a company above to edit its configuration.',
      elevateRewardsUnavailable:
        'Elevate Hispano does not use rewards, gifts, or vendor reviews. Use Pipeline & statuses to configure this company.',
      elevateGiftsUnavailable: 'Gifts are not part of the Elevate Hispano product surface.',
      elevateReviewsUnavailable: 'Vendor gift reviews are not part of the Elevate Hispano product surface.',
      contextLabel: 'Platform scope',
      allCompaniesContext: 'All companies',
      allCompaniesContextHint: 'Showing aggregated data across the entire platform.',
      clearContext: 'Clear filter',
      viewCompanyDetail: 'View company detail',
      viewCompanyUsers: 'View users',
      configureCompany: 'Configure company',
      viewAllUsers: 'View all users',
      systemAlerts: 'System alerts',
      alertPendingGifts: '{count} pending gift(s) need attention',
      alertNoClients: 'This company has no clients yet',
      topPerformingCompanies: 'Top performing companies',
      recentActivity: 'Recent registrations',
      noRecentActivity: 'No recent activity yet',
      adminUserType: 'Company admin',
      vendorUserType: 'Representative',
      clientUserType: 'Client',
      clientState: 'Client state',
      rewardPoints: 'Reward points',
      sortBy: 'Sort by',
      companyDetailTitle: 'Company detail',
      companyDetailSubtitle: 'Deep dive into tenant health, users, and activity.',
      companyComparison: 'Company comparison',
      clientStateBreakdown: 'Client state breakdown',
      companyScopedAnalytics: 'Scoped to selected company',
      failedToLoadAnalytics: 'Failed to load analytics',
      failedToLoadCompany: 'Failed to load company detail',
      companyNotFound: 'Company not found',
      companyNotFoundDesc: 'The selected company may have been removed or is unavailable.',
      backToCompanies: 'Back to companies',
      registeredOn: 'Registered on',
      viewCompanyProspects: 'View prospects',
      topVendors: 'Top representatives',
      topClients: 'Top clients',
      recentProspects: 'Recent prospects',
      recentClients: 'Recent clients',
      client: 'Client',
      noCompanyAdmins: 'No company admins assigned',
      noVendorsYet: 'No representatives yet',
      noActiveClientsYet: 'No active clients yet',
      noProspectsYet: 'No prospects yet',
      revenue: 'Revenue',
      viewDetails: 'View details',
      openSection: 'Open section',
      allUsers: 'All platform users',
      backupsTitle: 'Backups',
      backupsSubtitle: 'Download a full copy of every table and restore it if production data is ever lost.',
      backups: {
        heroTitle: 'Full platform backups',
        heroDescription: 'Create a complete, portable snapshot of every company, user, and record on the platform, then restore it from this same screen whenever you need to recover.',
        formatNote: 'Format: a ZIP archive with a JSON snapshot of all tables plus your uploaded files (avatars, reward images, and videos).',
        statTables: 'Tables',
        statRows: 'Data rows',
        statFiles: 'Stored files',
        statFileSize: 'File storage',
        inventorySummary: 'This backup will include {rows} rows and {files} uploaded files.',
        downloadTitle: 'Download backup',
        downloadDescription: 'Save a full copy of the platform to your computer.',
        includeFiles: 'Include uploaded files',
        includeFilesHint: 'Adds avatars, reward images, and videos. Turn off for a smaller, data-only backup.',
        downloadButton: 'Download backup',
        downloading: 'Preparing backup...',
        downloadSuccess: 'Backup downloaded',
        downloadError: 'Could not generate the backup',
        restoreTitle: 'Restore from backup',
        restoreDescription: 'Upload a backup file created on this screen to recover the platform.',
        warningTitle: 'This replaces all current data',
        warningText: 'Every table in the database will be overwritten with the contents of the backup. This cannot be undone, so make sure you download a fresh backup before continuing.',
        chooseFile: 'Backup file (.zip)',
        noFileSelected: 'No file selected yet.',
        confirmLabel: 'Type RESTORE to confirm',
        restoreButton: 'Restore backup',
        restoring: 'Restoring...',
        restoreConfirmTitle: 'Restore this backup?',
        restoreConfirmMessage: 'All current data will be replaced by the contents of the selected file. This action cannot be undone.',
        restoreConfirmAction: 'Yes, restore',
        restoreSuccess: 'Backup restored',
        restoreError: 'The restore failed',
        restoreResultTitle: 'Restore complete',
        restoreResultDescription: 'The data from your backup file is now live.',
        restoreResultTables: 'Tables restored',
        restoreResultFiles: 'Files restored',
        restoreResultSource: 'Backup created',
        reload: 'Reload page',
        loadError: 'Could not load the backup inventory',
        retry: 'Try again',
      },
    },
    // Sidebar
    sidebar: {
      dashboard: 'Dashboard',
      byCompany: 'By {company}',
      analytics: 'Analytics',
      referrals: 'Referrals',
      network: 'Network',
      rewards: 'Rewards',
      users: 'Users',
      importUsers: 'Import Users',
      myClients: 'Members',
      prospects: 'Prospects',
      partners: 'Partner network',
      pendingGifts: 'Pending gifts',
      giftsInTransit: 'Gifts in transit',
      myContacts: 'My contacts',
      vendorReviews: 'Representative reviews',
      videoHub: 'Video Hub',
      backups: 'Backups',
      settings: 'Settings',
      promotions: 'Promotions',
      logout: 'Logout',
    },
    promotions: {
      eyebrow: 'Raffles & prizes',
      title: 'Promotions',
      subtitle: 'Refer new people and earn tickets for the active Elevate Hispano raffles.',
      activeNow: 'Active raffle',
      startsOn: 'Starts {date}',
      endsOn: 'Closes {date}',
      drawOn: 'Draw {date}',
      requiredLabel: '{count} referrals',
      progressText: '{current} of {required} referrals',
      remainingOne: '1 more referral to earn your ticket',
      remainingMany: '{count} more referrals to earn your ticket',
      qualified: 'You are in! Your ticket is active.',
      inviteCta: 'Invite now',
      viewReferrals: 'View my links',
      myTickets: 'My tickets',
      myTicketsSubtitle: 'Each ticket is one entry in a raffle.',
      noTickets: 'No tickets yet',
      noTicketsDescription: 'Reach the referral goal of an active raffle and your ticket will show up here.',
      ticketCode: 'Ticket',
      cycleLabel: 'Period',
      wonPrize: 'You won {prize}',
      winners: 'Winners',
      winnersSubtitle: 'These are the winners of the recent draws.',
      youWon: 'You won!',
      statusActive: 'In play',
      statusWon: 'Winner',
      statusLost: 'Not won',
      noPromotions: 'No active promotions',
      noPromotionsDescription: 'Check back soon to see the available raffles.',
      loadError: 'Could not load promotions',
      prizeCash: 'Cash',
      prizePhysical: 'Prize',
      pastCycles: 'Draw history',
      adminTitle: 'Promotions',
      adminSubtitle: 'Manage raffle campaigns, periods and winners.',
      newPromotion: 'New promotion',
      editPromotion: 'Edit promotion',
      statPromotions: 'Promotions',
      statActive: 'Active',
      statTickets: 'Tickets',
      statWinners: 'Winners',
      active: 'Active',
      inactive: 'Inactive',
      referralsShort: 'refs',
      partnersShort: 'partners',
      ticketsShort: 'tickets',
      edit: 'Edit',
      delete: 'Delete',
      addCycle: 'Add period',
      participants: 'Participants',
      setWinner: 'Set winner',
      draw: 'Draw',
      drawn: 'Winner drawn',
      open: 'Open',
      scheduled: 'Scheduled',
      drawnLabel: 'Drawn',
      due: 'Draw pending',
      auditTitle: 'Draw audit',
      override: 'Manual winner',
      fieldTitle: 'Title',
      fieldPrize: 'Prize name',
      fieldPrizeType: 'Prize type',
      fieldRequired: 'Referrals required',
      fieldMinState: 'Minimum referral state',
      fieldValue: 'Prize value (cents)',
      fieldSubtitle: 'Subtitle',
      fieldDescription: 'Description',
      fieldImage: 'Prize image',
      countPartners: 'Count partners',
      exclusive: 'Exclusive',
      exclusiveClient: 'Exclusive client (email)',
      exclusiveClientHint: 'Leave empty so all clients can see and join.',
      cycleModalTitle: 'Period',
      fieldLabel: 'Label',
      fieldStart: 'Start',
      fieldEnd: 'End',
      fieldDraw: 'Draw date',
      fieldDrawHint: 'Leave empty to draw at the end date.',
      noParticipants: 'No tickets yet.',
      winner: 'Winner',
      reason: 'Reason',
      reasonRequired: 'Select a winner and provide a reason',
      requiredFields: 'Title and prize name are required',
      datesRequired: 'Start and end dates are required',
      saved: 'Saved',
      saveError: 'Could not save',
      save: 'Save',
      cancel: 'Cancel',
      deleted: 'Deleted',
      deleteTitle: 'Delete promotion',
      deleteMessage: 'Delete "{title}"? This cannot be undone.',
      deleteCycleTitle: 'Delete period',
      deleteCycleMessage: 'Delete period "{label}"?',
      drawTitle: 'Draw now',
      drawMessage: 'Draw a winner for "{label}" now? This cannot be undone.',
    },
    promotionsIntro: {
      eyebrow: 'Raffles & prizes',
      title: 'You can start winning prizes!',
      subtitle: 'Refer new people and join the Elevate Hispano raffles.',
      required: '{count} referrals',
      viewCta: 'View promotions',
      dismiss: 'Maybe later',
    },
    videoHub: {
      eyebrow: 'Learn',
      title: 'Video Hub',
      clientSubtitle: 'Watch training, product, and company videos prepared for members of your organization.',
      vendorSubtitle: 'Watch playbooks and company videos prepared for representatives of your organization.',
      nowPlaying: 'Featured',
      watchNow: 'Watch now',
      searchPlaceholder: 'Search videos...',
      allCategories: 'All',
      featured: 'Featured',
      emptyTitle: 'No videos yet',
      emptyDescription: 'Your company has not published videos for this hub. Check back soon.',
      noResultsTitle: 'No matching videos',
      noResultsDescription: 'Try another search or category.',
      relatedLinks: 'Related links',
      videoUnavailable: 'That video is no longer available in your hub.',
      loadError: 'Could not load videos',
      categories: {
        general: 'General',
        onboarding: 'Onboarding',
        training: 'Training',
        product: 'Product',
        announcements: 'Announcements',
      },
      adminEyebrow: 'Company library',
      adminTitle: 'Video Hub',
      adminSubtitle: 'Upload files or paste a URL. Visibility applies only to members and representatives inside this company.',
      addVideo: 'Add video',
      editVideo: 'Edit video',
      createVideo: 'Publish video',
      saveChanges: 'Save changes',
      companyContext: 'Company',
      chooseCompany: 'Choose a company...',
      companyHint: 'Each company has its own private library. Videos never leak across tenants.',
      pickCompanyTitle: 'Select a company',
      pickCompanyDescription: 'Use Platform scope above to choose a company. Video Hub is managed per tenant.',
      statTotal: 'Videos',
      statPublished: 'Published',
      statClients: 'For members',
      statVendors: 'For representatives',
      adminEmptyTitle: 'Build the company library',
      adminEmptyDescription: 'Add a YouTube/Vimeo link or upload an MP4. Choose whether members, representatives, or both can watch it.',
      draft: 'Draft',
      sourceUrl: 'URL',
      sourceFile: 'File',
      preview: 'Preview',
      edit: 'Edit',
      delete: 'Delete',
      fieldTitle: 'Title',
      fieldDescription: 'Description',
      fieldCategory: 'Category',
      fieldSortOrder: 'List position',
      sortHint: 'Featured videos still open the spotlight first. This only sorts the rest of the hub.',
      sortFirst: 'First in the list',
      sortHigh: 'Near the top',
      sortNormal: 'Default',
      sortLast: 'Last in the list',
      sortCustom: 'Custom position',
      fieldSource: 'Source',
      fieldUrl: 'Video URL',
      urlHint: 'YouTube, Vimeo, or a direct MP4/WEBM link.',
      fieldFile: 'Video file',
      chooseFile: 'Choose video file',
      fileHint: 'MP4, WEBM, MOV, OGG or M4V. Maximum 200 MB. Stored in /uploads/videos/<company_id>/.',
      fieldAudience: 'Who can watch',
      audienceClients: 'Members',
      audienceClientsHint: 'Only members of this company can watch it.',
      audienceVendors: 'Representatives',
      audienceVendorsHint: 'Only representatives of this company can watch it.',
      audienceBoth: 'Members and representatives',
      audienceAll: 'Everyone',
      audienceHintAll: 'Members and representatives of this company can watch it.',
      audienceRequired: 'Select at least one audience',
      fieldListing: 'How it appears',
      published: 'Published',
      publishedHint: 'Visible in the hub list for the selected audience.',
      featuredHint: 'Pinned to the spotlight at the top of the hub.',
      draftHint: 'Hidden from the hub until you publish it.',
      fieldThumbnail: 'Thumbnail URL',
      uploadThumbnail: 'Or upload a thumbnail image',
      fieldLinks: 'Related links',
      linkLabel: 'Label',
      addLink: 'Add link',
      removeLink: 'Remove',
      titleRequired: 'Title is required',
      urlRequired: 'Paste a video URL or switch to file upload',
      created: 'Video created',
      updated: 'Video updated',
      deleted: 'Video deleted',
      saveError: 'Could not save the video',
      deleteTitle: 'Delete this video?',
      deleteMessage: '“{title}” will be removed from this company hub. Uploaded files are deleted from disk.',
      deleteConfirm: 'Delete video',
    },
    // TopBar
    topBar: {
      settings: 'Settings',
      signOut: 'Sign out',
      useLightTheme: 'Use light theme',
      useDarkTheme: 'Use dark theme',
      pointsBalance: 'Reward points balance: {count}',
      notifications: 'Notifications',
      inviteWithQr: 'Invite with QR code',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
    },
    // Settings
    settings: {
      title: 'Settings',
      subtitle: 'Manage your account and preferences',
      sections: 'Sections',
      swipeHint: 'Swipe',
      sectionsAria: 'Settings sections',
      systemSettings: 'System Settings',
      profile: 'Profile',
      notifications: 'Notifications',
      privacy: 'Privacy',
      appearance: 'Appearance and Language',
      updateAccount: 'Update your account name and password',
      name: 'Name',
      yourName: 'Your name',
      changePassword: 'Change Password',
      leaveEmpty: 'Leave password fields empty if you don\'t want to change it',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
      enterCurrentPassword: 'Enter current password',
      enterNewPassword: 'Enter new password',
      confirmNewPasswordPlaceholder: 'Confirm new password',
      saveChanges: 'Save Changes',
      personalInfo: 'Personal Information',
      firstName: 'First Name',
      lastName: 'Last Name',
      bio: 'Biography',
      tellUs: 'Tell us about yourself...',
      saveProfile: 'Save Changes',
      profilePhoto: 'Profile photo',
      uploadPhoto: 'Upload photo',
      uploadingPhoto: 'Uploading...',
      removePhoto: 'Remove photo',
      avatarHint: 'Square images work best. Your photo appears in the sidebar menu.',
      avatarUploaded: 'Profile photo updated.',
      avatarRemoved: 'Profile photo removed.',
      avatarUploadFailed: 'Could not update profile photo.',
      avatarInvalidType: 'Please choose a valid image file (PNG, JPG, WEBP, or GIF).',
      avatarTooLarge: 'Image is too large. Maximum size is 5 MB.',
      notificationPreferences: 'Notification Preferences',
      emailNotifications: 'Email Notifications',
      emailNotificationsDesc: 'Receive notifications by email',
      pushNotifications: 'Push Notifications',
      pushNotificationsDesc: 'Real-time notifications',
      weeklyReports: 'Weekly Reports',
      weeklyReportsDesc: 'Weekly activity summary',
      newReferrals: 'New Referrals',
      newReferralsDesc: 'When someone uses your code',
      conversions: 'Conversions',
      conversionsDesc: 'When a conversion is completed',
      savePreferences: 'Save Preferences',
      privacySettings: 'Privacy Settings',
      publicProfile: 'Public Profile',
      publicProfileDesc: 'Make your profile visible to other users',
      showStats: 'Show Statistics',
      showStatsDesc: 'Show your statistics publicly',
      allowMessages: 'Allow Messages',
      allowMessagesDesc: 'Allow others to send you messages',
      dataSharing: 'Share Data',
      dataSharingDesc: 'Share anonymous data to improve service',
      optOutRight: 'Right to Opt-Out',
      optOutRightDesc: 'Exercise your right to opt out of the sale or sharing of your personal information with third parties',
      showActivityInSocialFeed: 'Show my activity in the community',
      showActivityInSocialFeedDesc: 'Let other members of your company see your achievements as activity toasts',
      savePrivacy: 'Save Configuration',
      appearanceLocalization: 'Appearance and Language',
      theme: 'Theme',
      light: 'Light',
      dark: 'Dark',
      auto: 'Automatic',
      language: 'Language',
      languageEn: 'English',
      languageEs: 'Spanish',
      languageChanged: 'Language updated',
      timezone: 'Timezone',
      dateFormat: 'Date Format',
      saveAppearance: 'Save Preferences',
      confirmChanges: 'Confirm Changes',
      confirmChangesDesc: 'Are you sure you want to update your settings with the following changes?',
      updating: 'Updating...',
      nameRequired: 'Name is required',
      currentPasswordRequired: 'Current password is required to change password',
      passwordsNoMatch: 'New passwords do not match',
      passwordTooShort: 'Password must be at least 6 characters',
      settingsUpdated: 'Settings updated successfully!',
      failedUpdate: 'Failed to update settings',
      errorUpdating: 'An error occurred while updating settings',
      savedSuccessfully: 'saved successfully',
      platformConfig: 'System Configuration',
      platformConfigDesc: 'Manage preconfigured pipeline statuses, sale types, and other system defaults.',
      systemConfig: {
        prospectStatusesTitle: 'Prospect statuses',
        prospectStatusesDesc: 'Manage pipeline stages. New prospects use the default status.',
        saleTypesTitle: 'Sale types',
        saleTypesDesc: 'Options shown when a prospect reaches a sale stage.',
        addStatus: 'Add status',
        addSaleType: 'Add sale type',
        code: 'Code',
        label: 'Label',
        labelPlaceholder: 'Display name',
        sortOrder: 'Sort order',
        badgeTone: 'Badge color',
        setAsDefault: 'Set as default status for new prospects',
        active: 'Active',
        defaultBadge: 'Default',
        inactiveBadge: 'Inactive',
        save: 'Save',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete',
        loading: 'Loading…',
        saved: 'Saved',
        deleted: 'Deleted',
        labelRequired: 'Label is required',
        failedToLoad: 'Failed to load system configuration',
        failedToLoadCompanies: 'Failed to load companies',
        companyLabel: 'Company',
        failedToSave: 'Failed to save',
        failedToDelete: 'Failed to delete',
        confirmDeleteStatus: 'Delete status "{name}"?',
        confirmDeleteSaleType: 'Delete sale type "{name}"?',
      },
    },
    // Referral Page
    referral: {
      loading: 'Loading...',
      welcome: 'Welcome!',
      referredBy: 'You were referred by',
      joinNow: 'Join Now',
      alreadyHaveAccount: 'Already have an account?',
      signIn: 'Sign In',
      register: 'Register',
      createAccount: 'Create Account',
      exclusiveRewards: 'Exclusive Rewards',
      exclusiveRewardsDesc: 'Earn unique benefits for each referral',
      premiumProgram: 'Premium Program',
      premiumProgramDesc: 'Access advanced system features',
      activeCommunity: 'Active Community',
      activeCommunityDesc: 'Join a network of committed users',
      registrationSuccessful: 'Registration successful! Welcome to our platform!',
      accountCreatedSuccess: 'Account created successfully!',
      registrationFailed: 'Registration failed',
      errorOccurred: 'An error occurred during registration',
      passwordsDoNotMatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 6 characters',
      invalidReferralLink: 'Invalid referral link',
      createYourAccount: 'Create Your Account',
      referredByLine: 'Referred by {name}',
      chooseUsername: 'Choose a username',
      emailPlaceholder: 'your.email@example.com',
      phonePlaceholder: '(555) 555-0123',
      phoneInvalid: 'Enter a valid 10-digit US phone number',
      passwordMinPlaceholder: 'At least 6 characters',
      confirmPasswordPlaceholder: 'Re-enter your password',
      invitedByLine: "You've been invited by {name}",
      joinProgramToday: 'Join our referral program and start earning today',
      whatAwaitsYou: 'What awaits you?',
      discoverBenefits: 'Discover the benefits of our program',
      goToHome: 'Go to Home',
      username: 'Username',
      email: 'Email',
      phone: 'Phone',
      dateOfBirth: 'Date of birth',
      dateOfBirthPlaceholder: 'Select your date of birth',
      dateOfBirthRequired: 'Date of birth is required',
      calendarPrevMonth: 'Previous month',
      calendarNextMonth: 'Next month',
      calendarClose: 'Close calendar',
      calendarSelectMonthYear: 'Choose month and year',
      calendarWeekdays: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
      },
      password: 'Password',
      confirmPassword: 'Confirm Password',
      registering: 'Creating account...',
      back: 'Back',
      registrationSuccessTitle: 'Registration Successful!',
      registrationSuccessMessage: 'Thank you for joining our program. Your referrer has been notified.',
      referralProgram: 'Referral Program',
      linkGeneratedBy: 'This link was generated by our referral system',
      brandName: 'Enrola',
      joinPartnerProgramToday: 'Join the partner program and start building your sales network today',
      partnerWhatAwaitsYou: 'What does the partner program offer?',
      partnerRewards: 'Referral earnings',
      partnerRewardsDesc: 'Earn rewards for every partner who joins',
      partnerGrowth: 'Sales tools',
      partnerGrowthDesc: 'Access tools to grow your business',
      partnerNetwork: 'Partner network',
      partnerNetworkDesc: 'Connect with other vendors in the company',
      partnerVideoTitle: 'Partner program video',
      programVideoTitle: 'Program video',
      continueWithRegistration: 'Continue with registration',
      partnerSubmit: 'Submit application',
      partnerRequestReceived: 'Application sent',
      partnerRequestReceivedTitle: 'Application received!',
      partnerRequestReceivedMessage: 'Your partner program application was sent. Your program leader will review your information and contact you. You will receive an email as you advance.',
      dateOfBirthOptional: 'Date of birth (optional)',
    },
    // Notifications
    notifications: {
      title: 'Notifications',
      all: 'All',
      unread: 'Unread',
      success: 'Success',
      info: 'Info',
      markAllRead: 'Mark all as read',
      loadMore: 'Load more',
      markAsRead: 'Mark as read',
      delete: 'Delete',
      loading: 'Loading notifications...',
      noNotifications: 'No notifications',
      noNotificationsDescription: 'You are all caught up. New alerts will appear here.',
      failedToLoad: 'Failed to load notifications',
      failedToMarkRead: 'Failed to mark notification as read',
      failedToMarkAllRead: 'Failed to mark all notifications as read',
      failedToUpdate: 'Failed to update notification',
      allMarkedRead: 'All notifications marked as read',
      failedToUpdateAll: 'Failed to update notifications',
      deleted: 'Notification deleted',
      failedToDelete: 'Failed to delete notification',
      viewDetails: 'Tap to view',
      fallbacks: {
        unknownVendor: 'A representative',
        unknownClient: 'A client',
        unknownProspect: 'A prospect',
        unknownMember: 'A member',
        unknownReward: 'A reward',
        unknownVideo: 'A video',
        theirVendor: 'their representative',
      },
      messages: {
        promotionTicketEarned: {
          title: 'You earned a ticket!',
          message: 'You reached {required} referrals in {promotionTitle} ({cycleLabel}). Your ticket is in play.',
        },
        promotionWinner: {
          title: 'You won the raffle!',
          message: 'Congratulations! You won {prizeName} in {promotionTitle}.',
        },
        clientReferralGenerated: {
          title: 'Client generated a referral',
          message: '{referrer} referred {newClient}.',
        },
        pointsEarnedReferral: {
          title: 'Points earned!',
          message: 'You earned {points} points! {newClient} joined using your referral.',
        },
        newReferral: {
          title: 'New referral',
          message: '{newClient} joined using your referral code.',
        },
        newRewardCatalog: {
          title: 'New reward in catalog',
          message: '{rewardName} is now available ({points} points).',
        },
        newVideoPublished: {
          title: 'New video in the hub',
          message: '{videoTitle} is now available in Video Hub.',
        },
        giftOnTheWay: {
          title: 'Gift on the way',
          message: 'Your {rewardName} was handed to {vendorName} and will be delivered soon.',
        },
        prospectEnrolled: {
          title: 'Prospect enrolled',
          message: '{vendorName} enrolled {clientName} as a new client.',
        },
        newProspect: {
          title: 'New prospect',
          message: '{vendorName} added prospect {prospectName}.',
        },
        prospectsImportedOne: {
          title: 'Prospects imported',
          message: '{vendorName} imported 1 prospect.',
        },
        prospectsImportedMany: {
          title: 'Prospects imported',
          message: '{vendorName} imported {count} prospects.',
        },
        newAffiliation: {
          title: 'New affiliation',
          message: '{username} joined the platform.',
        },
        clientProgressUpdatedAdmin: {
          title: 'Client progress updated',
          message: '{username} advanced to {state}.',
        },
        newReferralInNetwork: {
          title: 'New referral in network',
          message: '{referrer} referred {newClient}.',
        },
        newReferralSignup: {
          title: 'New referral signup',
          message: '{username} signed up using your referral link.',
        },
        newPartnerProspect: {
          title: 'New partner prospect',
          message: '{prospectName} joined your partner program.',
        },
        newPartnerProspectAdmin: {
          title: 'New partner prospect',
          message: '{prospectName} joined the partner program.',
        },
        partnerProspectStatus: {
          title: 'Partner prospect updated',
          message: '{prospectName} advanced to {status}.',
        },
        partnerProspectStatusAdmin: {
          title: 'Partner prospect updated',
          message: '{prospectName} advanced to {status}.',
        },
        partnerEnrolled: {
          title: 'Partner enrolled',
          message: '{partnerName} was enrolled as a partner.',
        },
        partnerEnrolledLeader: {
          title: 'Partner enrolled',
          message: '{partnerName} is now part of your partner network.',
        },
        welcomeBonus: {
          title: 'Welcome bonus!',
          message: 'You received {points} welcome points. Start exploring your rewards!',
        },
        pointsEarnedStateAdvance: {
          title: 'Points earned!',
          message: 'You earned {points} points! {username} advanced to {state}.',
        },
        clientReferralProgress: {
          title: 'Client referral progress',
          message: '{referrer} earned points because {username} advanced to {state}.',
        },
        clientProgressUpdatedVendor: {
          title: 'Client progress updated',
          message: '{username} has been moved from {fromState} to {toState}.',
        },
        statusUpdated: {
          title: 'Status updated',
          message: 'Your status has been updated to {state}.',
        },
        newRewardClaimVendor: {
          title: 'New reward claim',
          message: '{clientName} claimed {rewardName}. Prepare delivery to your client.',
        },
        rewardClaimPendingAdmin: {
          title: 'Reward claim pending',
          message: '{clientName} claimed {rewardName}. Hand the gift to {vendorName}.',
        },
        giftReadyForVendorDelivery: {
          title: 'Gift ready for client delivery',
          message: '{rewardName} for {clientName} is ready. Deliver it to your client.',
        },
        giftDelivered: {
          title: 'Gift delivered',
          message: 'Your {rewardName} has been delivered. Enjoy!',
        },
        shortActionPointsEarned: {
          title: 'Bonus points earned!',
          message: 'You earned {points} bonus points from a Short Action.',
        },
        shortActionInvite3Complete: {
          title: '3 invites today — bonus unlocked!',
          message: 'You invited 3 people today and earned {points} bonus points.',
        },
        missionPointsEarned: {
          title: 'Mission completed!',
          message: 'You completed a daily mission and earned {points} points.',
        },
        missionInvite3Complete: {
          title: 'Invite mission completed!',
          message: 'You hit today’s invite goal and earned {points} points.',
        },
        chestOpened: {
          title: 'Chest opened!',
          message: 'You earned {points} extra points from your {tier} chest.',
        },
      },
    },
    // Social activity
    socialActivity: {
      title: 'Community activity',
      socialLabel: 'Community activity',
      personalLabel: 'Notification',
      fallbackActor: 'A member',
      fallback: '{name} completed an action.',
      contentTypes: {
        video: 'a video',
        reward: 'a reward',
      },
      events: {
        points_earned: '{name} earned {points} points',
        referral_joined: '{name} invited a new member',
        reward_claimed: '{name} redeemed {reward_name}',
        gift_delivered: '{name} received a gift: {reward_name}',
        gift_confirmed: '{name} confirmed receipt of {reward_name}',
        pipeline_advanced: '{name} advanced to {state}',
        content_published: '{name} published {contentType}: {title}',
      },
    },
    // Admin Dashboard
    admin: {
      dashboard: 'Dashboard',
      users: 'Users',
      analytics: 'Analytics',
      importUsers: 'Import Users',
      rewards: 'Rewards',
      totalUsers: 'Total Users',
      activeUsers: 'Active Users',
      totalReferrals: 'Total Referrals',
      conversionRate: 'Conversion Rate',
      addUser: 'Add User',
      editUser: 'Edit User',
      deleteUser: 'Delete User',
      userDetails: 'User Details',
      import: 'Import',
      export: 'Export',
      filter: 'Filter',
      sort: 'Sort',
      searchUsers: 'Search users...',
      all: 'All',
      clients: 'Clients',
      vendors: 'Representatives',
      vendorRole: 'Representative',
      admins: 'Admins',
      adminControlCenter: 'Admin Control Center',
      completeSystemOverview: 'Complete system overview and management tools at your fingertips.',
      systemAdministrator: 'System Administrator',
      systemAnalytics: 'System Analytics',
      userManagement: 'User Management',
      systemSettings: 'System Settings',
      notifications: 'Notifications',
      rewardsManagement: 'Rewards Management',
      adminDashboard: 'Admin Dashboard',
      monitorSystemPerformance: 'Monitor system performance and user metrics',
      manageUsersDescription: 'Manage users and their referral activities',
      manageUsers: 'Manage users',
      quickActions: 'Quick actions',
      viewAnalytics: 'View analytics',
      rewardsSystem: 'Rewards system',
      platformStatistics: 'Platform statistics',
      configureSystemSettings: 'Configure system settings and preferences',
      systemAlerts: 'System alerts and important updates',
      configureRewardPoints: 'Configure reward points and manage rewards catalog',
      welcomeBack: 'Welcome back, {name}! Here\'s your system overview.',
      totalRevenue: 'Total Revenue',
      growthAnalytics: 'Growth Analytics',
      advancedAnalytics: 'Advanced analytics and insights to understand your referral program performance',
      activeReferrals: 'Active Referrals',
      activeReferrers: 'Active Referrers',
      totalPlatformRevenue: 'Total platform revenue',
      registeredPlatformUsers: 'Registered platform users',
      totalSuccessfulReferrals: 'Total successful referrals',
      clientsMakingReferrals: 'Clients making referrals',
      platformRevenue: 'Platform revenue',
      allUsers: 'All users',
      platformReferrals: 'Platform referrals',
      recentUsers: 'Recent Users',
      viewAllUsers: 'View All Users',
      userOverview: 'User Overview',
      latestUserRegistrations: 'Latest user registrations and activity',
      totalVendors: 'Total Representatives',
      totalClients: 'Total Clients',
      avgReferralsPerClient: 'Avg Referrals/Client',
      activeReferralRate: 'Active Referral Rate',
      administrators: 'Administrators',
      searchByUsername: 'Search by username, email, or phone...',
      dateJoined: 'Date Joined',
      user: 'User',
      type: 'Type',
      contact: 'Contact',
      joined: 'Joined',
      actions: 'Actions',
      viewDetails: 'View Details',
      clientStateDistribution: 'Client State Distribution',
      prospectStateDistribution: 'Prospect State Distribution',
      completionRate: 'Completion Rate',
      affiliated: 'Affiliated',
      contacted: 'Contacted',
      visited: 'Visited',
      completed: 'Completed',
      keyPerformanceIndicators: 'Key Performance Indicators',
      activeReferralLinks: 'Active Referral Links',
      totalClicks: 'Total Clicks',
      topVendors: 'Top Representatives',
      topClients: 'Top Clients',
      noVendorsYet: 'No representatives yet',
      noActiveClientsYet: 'No active clients yet',
      revenueAnalytics: 'Revenue Analytics',
      fromReferrals: 'From {count} referrals',
      revenuePerReferral: 'Revenue per Referral',
      standardCommission: 'Standard commission',
      revenuePerVendor: 'Revenue per representative',
      averageAcrossVendors: 'Average across {count} representatives',
      importUsersFromExcel: 'Import Users from Excel',
      chooseImportType: 'Choose the type of users you want to import and upload an Excel file following the template.',
      importVendors: 'Import Representatives',
      importClients: 'Import Clients',
      downloadTemplate: 'Download Template',
      uploadFileToPreview: 'Upload File to Preview',
      selectVendor: 'Select representative for client assignment',
      selectAVendor: 'Select a representative...',
      allImportedClientsAssigned: 'All imported clients will be assigned to the selected representative.',
      clientsLabel: 'clients',
      noPhone: 'No phone',
      noUsersFound: 'No users found',
      tryAdjustingFilters: 'Try adjusting your filters or search term.',
      username: 'Username',
      vsLastPeriod: 'vs last period',
      last7Days: 'Last 7 days',
      importFailed: 'Import failed',
      pleaseSelectVendor: 'Please select a representative for client import',
      failedToLoadVendors: 'Failed to load representatives',
      failedToDownloadTemplate: 'Failed to download template',
      invalidServerResponse: 'Invalid response from server',
      importPreviewErrors: 'Preview: {valid} valid, {invalid} with errors',
      importPreviewReady: 'Preview generated: {valid} records ready to import',
      failedToParseExcel: 'Failed to parse Excel file',
      importedCount: 'Imported {count} {type}',
      importedCountWithEmails: 'Imported {count} {type}. Access emails sent: {emails}',
      importPartialErrors: '{count} records had errors',
      errorLoadingUsers: 'Error loading users',
      memberSince: 'Member Since',
      referredBy: 'Referred By',
      userDetailsComingSoon: 'Additional user management features will be available here.',
      fullName: 'Full name',
      email: 'Email',
      phone: 'Phone',
      saveUserChanges: 'Save changes',
      userUpdated: 'User updated',
      userUpdatedAndNotified: 'User updated and notified by email',
      userUpdateFailed: 'Failed to update user',
      setTemporaryPassword: 'Set temporary password (optional)',
      leaveBlankToKeepPassword: 'Leave blank to keep current password',
      temporaryPasswordHint: 'If set, the user will be emailed the new password.',
      resetPasswordSectionTitle: 'Password reset',
      resetPasswordSectionHint: 'Send a secure link so the user can choose a new password.',
      sendPasswordResetLink: 'Send reset link',
      passwordResetLinkSent: 'Password reset link sent',
      passwordResetQueued: 'Password reset requested',
      passwordResetFailed: 'Failed to send reset link',
      importPreviewTitle: 'Import Preview ({ready} ready, {errors} errors)',
      importPreviewHint: 'Only records with "ready" status will be imported.',
      searchImportPreview: 'Search import preview...',
      filterImportStatus: 'Import status',
      importColRow: 'Row',
      importColReferredBy: 'Referred By',
      importStatusReady: 'Ready',
      cancelPreview: 'Cancel Preview',
      importRecords: 'Import {count} Records',
      importModalTitle: 'Import {type} from Excel',
      importModalInstructions: 'Upload an .xlsx file following the template. Required columns (in order): Username, Email, Password, Phone.',
      selectVendorBeforeUpload: 'Please select a representative before uploading client data.',
      uploadingParsing: 'Uploading and parsing...',
      pointsLabel: '{count} points',
    },
    // Vendor Dashboard
    vendor: {
      dashboard: 'Dashboard',
      clients: 'Members',
      analytics: 'Analytics',
      addClient: 'Add Client',
      editClient: 'Edit Client',
      clientDetails: 'Client Details',
      totalClients: 'Total Clients',
      activeClients: 'Active Clients',
      totalCommission: 'Total Commission',
      clientReferrals: 'Client Referrals',
      activeClientsLabel: 'Active Clients',
      totalProspects: 'Total Prospects',
      prospectsInPipeline: 'In your sales pipeline',
      percentConverted: '{percent}% converted',
      linkMemberConversions: 'Link sign-ups',
      linkMemberConversionsDesc: 'Members who joined via your referral link',
      linkConversionRateLabel: '{percent}% conversion rate',
      assignedClients: 'Assigned clients',
      totalEarnings: 'Total earnings',
      totalReferrals: 'Total referrals',
      makingReferrals: 'Making referrals',
      settings: 'Representative Settings',
      dashboardTitle: 'Representative Dashboard',
      clientAnalytics: 'Client Analytics',
      analyticsSubtitle: 'Monitor client performance and referral metrics',
      analyticsPeriodHint: 'Metrics for the selected period',
      clientsSubtitle: 'Manage your members and their referral activities',
      settingsSubtitle: 'Configure your representative account settings',
      notificationsSubtitle: 'Important updates and client activities',
      promoSubtitle: 'Photo, QR by program, share SMS / email / social',
      welcomeOverview: 'Welcome back, {name}! Here\'s your client overview.',
      vendorPortal: 'Representative Portal',
      vendorPortalDesc: 'Manage your clients and track their referral performance.',
      salesRep: 'Sales Representative',
      commissionEarned: 'Commission Earned',
      commissionFromReferrals: 'Total commission from referrals',
      recentClients: 'Recent Clients',
      viewAllClients: 'View All Clients',
      clientOverview: 'Client Overview',
      clientRosterDesc: 'Your client roster and their referral activity',
      joined: 'Joined',
      referralsLabel: 'referrals',
      active: 'Active',
      code: 'Code',
      noClientsYet: 'No Clients Yet',
      noClientsYetDesc: 'Your clients will appear here once they are assigned to you.',
      manageClients: 'Manage Clients',
      performanceSummary: 'Performance Summary',
      thisMonth: 'This Month',
      earned: 'earned',
      newClientsMonth: 'New Clients (Month)',
      clientsUnit: 'clients',
      monthlyReferrals: 'Monthly Referrals',
      topClient: 'Top Client',
      completionRate: 'Completion Rate',
      failedLoadAnalytics: 'Failed to load representative analytics data',
      failedLoadTrends: 'Failed to load representative trends data',
      errorLoadingClients: 'Error loading clients',
      clientAdvanced: 'Client advanced to {state} state!',
      pointsAwarded: '+{count} points awarded',
      failedAdvanceState: 'Failed to advance client state',
      couldNotLoadReferralTree: 'Could not load referral tree',
      managePortfolio: 'Manage and monitor your member portfolio',
      searchClients: 'Search by name, email, or phone...',
      filterByState: 'Filter by state',
      noMatchingMembers: 'No members match your search or filters.',
      viewReferralTree: 'View referral tree',
      viewReferralTreeFor: 'View referral tree for {name}',
      referredBy: 'Referred by',
      rewardPoints: 'Reward Points',
      referralCode: 'Referral Code',
      advancing: 'Advancing...',
      advanceTo: 'Advance to {state}',
      advanceClientTo: 'Advance Client to {state}',
      confirmAdvanceTitle: 'Advance {name}?',
      confirmAdvanceMessage: 'Move this client to "{state}"? This updates their pipeline stage and may award points.',
      confirmAdvanceConfirm: 'Advance stage',
      saleCompleted: 'Sale Completed!',
      saleCompletedFinal: 'Sale Completed - Client at Final State!',
      noClientsAssigned: 'No members assigned',
      noClientsAssignedDesc: 'You don\'t have any members assigned to you yet. Contact your administrator to get members assigned to your account.',
      backToDashboard: 'Back to Dashboard',
      clientStateDistribution: 'Client State Distribution',
      prospectStateDistribution: 'Prospect State Distribution',
      monthlyPerformance: 'Monthly Performance',
      newClients: 'New Clients',
      newReferrals: 'New Referrals',
      monthlyCommission: 'Monthly Commission',
      avgPerClient: 'Avg per Client',
      topPerformingClients: 'Top Performing Clients',
      commission: 'Commission',
      noActiveClientsYet: 'No Active Clients Yet',
      noActiveClientsYetDesc: 'Your clients will appear here once they start making referrals.',
      performanceMetrics: 'Performance Metrics',
      contactRate: 'Contact Rate',
      avgReferralsPerClient: 'Avg Referrals/Client',
      revenuePerClient: 'Revenue per Client',
      commissionBreakdown: 'Commission Breakdown',
      percentOfTotal: '{percent}% of total',
      commissionRate: 'Commission Rate',
      perReferral: 'Per referral',
      allTime: 'all time',
      percentActive: '{percent}% active',
      notAvailable: 'N/A',
      clientSince: 'Client Since',
      currentState: 'Current State',
      clientJourneyProgress: 'Client Journey Progress',
      clientStates: {
        affiliated: 'Affiliated',
        contacted: 'Contacted',
        visited: 'Visited',
        completed: 'Reward delivered',
      },
      prospects: {
        title: 'Prospects',
        subtitle: 'Track leads through your sales pipeline. Import from Excel or add prospects one at a time.',
        newProspect: 'New prospect',
        importExcel: 'Import Excel',
        downloadTemplate: 'Download template',
        failedToDownloadTemplate: 'Failed to download template',
        excelHint: 'Excel: first row headers name, optional email, phone (US (555) 555-0123), address, notes.',
        loading: 'Loading…',
        empty: 'No prospects yet. Import Excel or use New prospect to add your first lead.',
        colProspectionLevel: 'Level',
        colName: 'Name',
        colType: 'Type',
        colAddress: 'Address',
        colPhone: 'Phone',
        colEmail: 'Email',
        colStatus: 'Status',
        colSaleType: 'Sale type',
        colActions: 'Actions',
        colEnroll: 'Enrola',
        colVendor: 'Representative',
        enroll: 'Enrola',
        typeLabel: 'Prospect type',
        typeClient: 'Client',
        typePartner: 'Partner',
        filterByType: 'Filter by type',
        enrollPartner: 'Enroll partner',
        partnerEnrolledSuccess: '{name} is now a partner!',
        confirmEnrollPartnerMessage: 'A partner account will be created and an email will be sent to set their password. They will leave the prospect pipeline.',
        assignLeader: 'Assign leader',
        noLeader: 'No leader',
        enrolledSuccess: '{name} is now a client!',
        failedToEnroll: 'Failed to enroll prospect',
        confirmEnrollTitle: 'Enroll {name} as a client?',
        confirmEnrollMessage: 'They will move to your client list and leave the prospect pipeline. This cannot be undone from this screen.',
        adminSubtitle: 'View all company prospects and update their pipeline status.',
        adminEmpty: 'No prospects in the pipeline yet.',
        searchPlaceholder: 'Search by name, email, phone, or address...',
        filterByStatus: 'Filter by status',
        filterByVendor: 'Filter by representative',
        noMatchingProspects: 'No prospects match your search or filters.',
        delete: 'Delete',
        viewDetails: 'View details',
        editProspect: 'Edit prospect',
        editProspectTitle: 'Edit prospect',
        editModalDesc: 'Update prospect details and manage notes.',
        saveChanges: 'Save changes',
        updatedSuccess: 'Prospect updated',
        notesCalendarTitle: 'Calendar',
        notesCalendarSubtitle: 'Notes and appointments for {name}',
        notesCalendarPickDay: 'Select a day to view notes or schedule an appointment.',
        calendarAddNoteLabel: 'Add note for this day',
        calendarAddNotePlaceholder: 'Write a note for the selected date…',
        notesCalendarNoNotesOnDay: 'No notes on {date}.',
        notesCalendarDayTitle: 'Activity on {date}',
        calendarAppointmentsTitle: 'Appointments',
        calendarNoAppointmentsOnDay: 'No appointments on this day.',
        calendarNotesTitle: 'Notes',
        calendarScheduleAppointment: 'Schedule appointment',
        calendarStartTime: 'Start time',
        calendarEndTime: 'End time',
        calendarInvalidTimeRange: 'End time must be after start time.',
        calendarAppointmentNoteLabel: 'Appointment notes (optional)',
        calendarAppointmentNotePlaceholder: 'Add details about the visit or meeting…',
        calendarScheduleAppointmentButton: 'Schedule appointment',
        appointmentScheduledSuccess: 'Appointment scheduled',
        failedToScheduleAppointment: 'Failed to schedule appointment',
        calendarPrevMonth: 'Previous month',
        calendarNextMonth: 'Next month',
        calendarWeekdays: {
          sun: 'Sun',
          mon: 'Mon',
          tue: 'Tue',
          wed: 'Wed',
          thu: 'Thu',
          fri: 'Fri',
          sat: 'Sat',
        },
        addNote: 'Add note',
        addNoteTitle: 'Add note',
        addNoteSubtitle: 'This note will be saved with today\'s date ({date}).',
        addNotePlaceholder: 'Write a new note for this prospect…',
        noteAddedSuccess: 'Note added',
        notesHistory: 'Notes history',
        saveNotes: 'Save notes',
        notesSaved: 'Notes saved',
        detailTitle: 'Prospect details',
        address: 'Address',
        notes: 'Notes',
        noNotes: 'No notes added',
        createdAt: 'Created',
        updatedAt: 'Last updated',
        close: 'Close',
        confirmDelete: 'Delete prospect "{name}"?',
        createdSuccess: 'Prospect created',
        deletedSuccess: 'Prospect deleted',
        importSuccess: 'Imported {count} row(s)',
        failedToLoad: 'Failed to load prospects',
        failedToCreate: 'Failed to create prospect',
        failedToUpdate: 'Failed to update prospect',
        failedToDelete: 'Failed to delete prospect',
        failedToImport: 'Could not import spreadsheet',
        createModalDesc: 'Save the prospect to your pipeline. Contact fields are optional and can be edited later.',
        nameRequired: 'Name is required',
        emailInvalid: 'Enter a valid email address',
        phoneInvalid: 'Enter a valid 10-digit US phone number',
        nameLabel: 'Full name or business *',
        namePlaceholder: 'e.g. Jane Smith or Acme Water Co.',
        emailLabel: 'Email',
        emailPlaceholder: 'name@company.com',
        phoneLabel: 'Phone',
        addressLabel: 'Address',
        addressPlaceholder: '123 Main St, City, ST 12345 (optional)',
        apartmentLabel: 'Apartment',
        apartmentPlaceholder: 'Apt, suite, unit… (optional)',
        creationProfileTitle: 'Prospect creation',
        creationProfileOptional: 'Optional — leave unanswered if unknown.',
        worksLabel: 'Works?',
        marriedLabel: 'Married?',
        housingLabel: 'Own home or rent?',
        ownsHomeLabel: 'Own home',
        rentsHomeLabel: 'Rent',
        prospectionLevelLabel: 'Prospection level',
        prospectionLevelHint: 'Optional — rate the quality of this prospect from 1 to 5 stars.',
        addressSearching: 'Searching addresses…',
        notesLabel: 'Notes',
        notesPlaceholder: 'Context for your team — next step, source, etc.',
        statusLabel: 'Prospect status',
        saleType: 'Sale type',
        saleTypeUnset: 'Not sure yet',
        back: 'Back',
        next: 'Next',
        saving: 'Saving…',
        create: 'Create prospect',
        statuses: {
          NEW: 'New',
          CALL: 'Call',
          VISIT: 'Visit',
          DEMO: 'Demo',
          SALE: 'Sale',
          INTERVIEW: 'Interviewed',
          NOT_INTERESTED: 'Not interested',
        },
        saleTypes: {
          CASH: 'Cash',
          CREDIT: 'Credit',
        },
      },
    },
    // Rewards
    rewards: {
      title: 'Rewards Configuration',
      pointConfigs: 'Point Configurations',
      rewards: 'Rewards',
      addReward: 'Add Reward',
      editReward: 'Edit Reward',
      deleteReward: 'Delete Reward',
      name: 'Name',
      description: 'Description',
      pointsRequired: 'Points Required',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      create: 'Create',
      update: 'Update',
      savedSuccessfully: 'Point configurations saved successfully!',
      failedToSave: 'Failed to save configurations',
      createdSuccessfully: 'Reward created successfully!',
      failedToCreate: 'Failed to create reward',
      updatedSuccessfully: 'Reward updated successfully!',
      failedToUpdate: 'Failed to update reward',
      deletedSuccessfully: 'Reward deleted successfully!',
      failedToDelete: 'Failed to delete reward',
      fillRequiredFields: 'Please fill in all required fields',
      loading: 'Loading rewards configuration...',
      failedToLoad: 'Failed to load rewards configuration',
      rewardsConfiguration: 'Rewards Configuration',
      configureRewardPoints: 'Configure reward points for client states and manage available rewards',
      stateRewardPoints: 'State Reward Points',
      configurePointsAwarded: 'Configure points awarded to referrers when their referred clients advance through states',
      editPoints: 'Edit Points',
      rewardPoints: 'Reward Points',
      whenClientRefers: 'When a client refers another person',
      whenSellerContacts: 'When representative contacts the affiliate by phone',
      whenSellerVisits: 'When representative visits the affiliate in person',
      whenSaleCompleted: 'When sale is completed',
      rewardsCatalog: 'Rewards Catalog',
      manageRewardsRedeem: 'Manage rewards that clients can redeem with their points',
      noRewardsYet: 'No Rewards Yet',
      createFirstReward: 'Create your first reward for clients to redeem',
      points: 'points',
      inactive: 'Inactive',
      createReward: 'Create Reward',
      createNewReward: 'Create New Reward',
      rewardName: 'Reward Name',
      active: 'Active',
      confirmDeleteReward: 'Are you sure you want to delete this reward?',
      describeReward: 'Describe the reward...',
      rewardNamePlaceholder: 'e.g., $50 Gift Card',
      welcomeBonusSection: 'Welcome Bonus',
      welcomeBonusSectionDesc: 'Points automatically gifted to every new client when they join the platform',
      welcomeBonus: 'New member welcome bonus',
      welcomeBonusDesc: 'Awarded once when a client creates their account',
      imageUrl: 'Product image URL',
      imageUrlPlaceholder: '/api/rewards/images/product-photo.jpg',
      imageSection: 'Product image',
      imageUpload: 'Upload from device',
      imageUploading: 'Uploading...',
      imageUploaded: 'Image uploaded successfully.',
      imageUploadFailed: 'Could not upload image.',
      imageUploadHint: 'Upload a file or paste an image URL. PNG, JPG, WEBP, or GIF up to 5 MB.',
      imageInvalidType: 'Please choose a valid image file (PNG, JPG, WEBP, or GIF).',
      imageTooLarge: 'Image is too large. Maximum size is 5 MB.',
      formPreview: 'Card preview',
      formPreviewHint: 'Update the URL to change how this reward appears in the catalog.',
      formPreviewExpand: 'View full image',
      formPreviewExpandHint: 'Click the preview to view the full image.',
      formImageViewTitle: 'Reward image',
      formDetails: 'Reward details',
      welcomeChoiceLabel: 'Show as welcome gift option for new members',
      welcomeChoiceBadge: 'Welcome gift',
      deliverySettingsTitle: 'Gift delivery timelines',
      deliverySettingsDesc: 'Set how long representatives have to deliver gifts, when delay warnings appear, and what clients are told about arrival time.',
      editDeliverySettings: 'Edit timelines',
      deliverySettingsSaved: 'Delivery timelines saved successfully!',
      deliverySettingsFailed: 'Failed to save delivery timelines',
      deliveryOverdueDayInvalid: 'Overdue warning day cannot exceed the representative delivery deadline',
      vendorDeliveryDaysLabel: 'Representative delivery window',
      vendorDeliveryDaysDesc: 'Days the representative has to deliver the gift after receiving it from admin',
      vendorOverdueDayLabel: 'Overdue warning day',
      vendorOverdueDayDesc: 'On this day of the delivery window, a red delay warning is shown to the representative',
      clientDeliveryDaysLabel: 'Client promised delivery',
      clientDeliveryDaysDesc: 'Tell clients their gift will arrive in less than this many days',
      missionsSection: 'Daily Missions Points',
      missionsSectionDesc: 'Enable or disable each daily mission and set the points awarded on completion',
      missionsVendorNote: 'Vendor missions can also award extra points',
      chestsSection: 'Chests by lifetime points',
      chestsSectionDesc: 'Set how often a chest is earned, its tier pattern and the random points it awards when opened.',
      chestsEnabled: 'Enable chests',
      chestsInactive: 'Chests are disabled for this company.',
      chestPointsInterval: 'Points per chest',
      chestPointsIntervalDesc: 'Every how many lifetime points a new chest appears on the route.',
      chestBronzePerSilver: 'Bronze chests per silver',
      chestBronzePerSilverDesc: 'Every N chests, the next milestone is silver instead of bronze.',
      chestSilverPerGold: 'Silver chests per gold',
      chestSilverPerGoldDesc: 'Every N silver chests, the next milestone is gold.',
      chestTierRanges: 'Random points per tier',
      chestRangeHint: 'The maximum must be lower than the next chest interval so one chest cannot unlock another by itself.',
      chestBronzeRange: 'Bronze range',
      chestSilverRange: 'Silver range',
      chestGoldRange: 'Gold range',
      chestMin: 'Min',
      chestMax: 'Max',
      chestPatternPreview: 'Pattern preview',
      chestPatternText: '1 chest every {points} pts · 4 bronze + 1 silver every {silver} pts · 1 gold every {gold} pts',
      chestsSaved: 'Chest settings saved',
      chestsFailed: 'Could not save chest settings',
      chestsMaxError: 'The {tier} maximum must be lower than {cap} pts.',
      chestsInvalidRange: 'The minimum cannot be greater than the maximum.',
      missionsResetPeriod: 'Mission refresh',
      missionsResetPeriodDesc: 'How often missions reset and become available again',
      missionsResetDaily: 'Daily',
      missionsResetWeekly: 'Weekly',
      clientMissionsLabel: 'Client missions',
      vendorMissionsLabel: 'Vendor missions',
      daysUnit: 'days',
      dayNumber: 'Day {day}',
    },
    welcomeOnboarding: {
      eyebrow: 'Welcome',
      title: 'Hello, {name}',
      subtitle: 'Your account is ready. We have credited a welcome bonus so you can get started with an advantage.',
      subtitleElevate: 'Your account is ready. We credited {points} points — equivalent to 10% off your Elevate Hispanos event ticket.',
      bonusLabel: 'Bonus credited',
      pointsGifted: 'points added to your balance',
      acceptBonus: 'Continue',
      readyEyebrow: 'Welcome gift',
      rewardReadyTitle: 'Choose your gift',
      rewardReadySubtitle: 'You have {points} points available. Select the benefit you want to redeem now.',
      chooseRewardHint: 'All options require the same number of points.',
      chooseRewardHintElevate: 'Redeem your {points} points for 10% off your event ticket.',
      selectedRewardLabel: 'Selected: {reward}',
      selectReward: 'Please select a welcome gift to continue.',
      claimingReward: 'Processing redemption...',
      claimFailed: 'Could not claim the selected reward. Please try again.',
      defaultRewardName: 'Royal Prestige® Santoku Knife 5"',
      defaultRewardDescription: 'Japanese-style 5" Santoku knife with German stainless steel — ideal for slicing, dicing and everyday prep.',
      pointsBadge: '{count} pts',
      redeemNow: 'Redeem gift',
      backToBonus: 'Back',
      friendFallback: 'friend',
    },
    enrola: {
      giftsHome: 'Home',
      motivationalBanner: {
        greeting: 'Hey, {name}',
      },
      clientHome: {
        homeSubtitle: 'Browse rewards, track your points, and invite friends in one place.',
        welcomeEyebrow: 'Your rewards shop',
        welcomeTitle: 'Hi, {name}',
        welcomeSubtitle: 'Redeem points for gifts and grow your network with a quick scan.',
        pointsBalance: 'Reward balance',
        viewAllRewards: 'View all rewards',
        nextGift: 'Next gift',
        shopEyebrow: 'Redeem',
        shopTitle: 'Popular rewards',
        shopSubtitle: 'Claim gifts with your points — delivery tracked in your account.',
        viewCatalog: 'See full catalog',
        inviteEyebrow: 'Quick invite',
        inviteTitle: 'Refer a friend',
        inviteSubtitle: 'Share your link or let them scan your QR code.',
        scanToJoin: 'Scan to join the program',
        openReferrals: 'All referral programs',
        noInviteLink: 'Your invite link is being prepared.',
        referralsEyebrow: 'Your network',
        referralsTitle: 'People you referred',
        viewAllReferrals: 'View all',
        readyToClaim: 'Available',
        inTransit: 'On the way',
        lockedReward: 'Locked',
        pointsToGo: '{count} pts to go',
        referralsSubtitle: 'Your network grows with every person you invite.',
        noReferralsYet: 'No referrals yet — share your QR code to get started.',
        inviteFirstReferral: 'Invite someone',
      },
      chests: {
        eyebrow: 'Chest route',
        title: 'Your chests',
        subtitle: 'Every {points} lifetime points unlocks a chest.',
        nextIn: '{points} pts to the next chest',
        nextReady: 'Next chest unlocked!',
        progress: '{current}/{target} pts',
        available: 'Available',
        opened: 'Opened',
        locked: 'Locked',
        open: 'Open',
        opening: 'Opening...',
        openingTitle: 'Opening your chest',
        openingHint: 'One moment...',
        openHint: 'Tap the chest to open it.',
        lockedHint: '{points} pts to go',
        bronze: 'Bronze',
        silver: 'Silver',
        gold: 'Gold',
        tierChest: 'Chest',
        pointsUnit: 'PTS',
        availableCount: '{count} available',
        openTitle: '{tier} chest!',
        rewardLabel: 'Points earned',
        newBalance: 'Your new balance is {points} pts.',
        great: 'Great!',
        openFailed: 'Could not open the chest.',
      },
      partnerHome: {
        inviteEyebrow: 'Partner program',
        inviteTitle: 'Invite a partner',
        inviteSubtitle: 'Share your link or let them scan the QR code to join as vendors.',
        scanToJoin: 'Scan to join as a partner',
        openReferrals: 'Partner program',
        noInviteLink: 'Your partner link is being prepared.',
      },
      inviteSwitchClients: 'Clients',
      inviteSwitchPartners: 'Partners',
      myPoints: 'My Points',
      myPointsUnit: 'PTS',
      myPointsSubtitle: 'Your reward points balance',
      missions: {
        eyebrow: 'Grow today',
        title: 'Daily Missions',
        motivationClient: 'Complete your missions to grow your network and earn extra points.',
        motivationVendor: 'Complete your missions to grow your business and earn extra points.',
        dailyTitle: 'Daily Mission',
        completedLabel: 'Done',
        completedToday: 'Completed missions',
        allDone: 'All daily missions cleared — great work!',
        pointsEarned: 'You earned {count} points for completing a mission!',
        shareLinkToday: 'Share your invite link today',
        shareLinkTodayDesc: 'Copy or share your link once today',
        inviteToday: 'Invite {target} friends today',
        inviteTodayDesc: 'Share your link — {current}/{target} registered today',
        browseRewardsToday: 'Browse the rewards shop',
        browseRewardsTodayDesc: 'Visit the shop and check available rewards',
        remindContactedToday: 'Send a reminder today',
        remindContactedTodayDesc: 'Message a contacted referral — {vendorName} will be reaching out soon',
        remindVisitedToday: 'Encourage a visitor today',
        remindVisitedTodayDesc: 'Send a motivational email to a referral after their visit',
        congratulateToday: 'Daily congratulations',
        congratulateTodayDesc: 'Celebrate a referral who completed their journey',
        welcomeToday: 'Give a welcome today',
        welcomeTodayDesc: 'Send a welcome email to your new affiliated referral',
        callAffiliatedToday: 'Call an affiliated member today',
        callAffiliatedTodayDesc: 'Tap to copy their phone number',
        callContactedToday: 'Call a contacted member today',
        callContactedTodayDesc: 'Follow up while they are in contacted stage',
        followUpToday: 'Follow up with a member today',
        followUpTodayDesc: 'Tap to copy their phone number',
        createProspectsToday: 'Create {target} new prospects today',
        createProspectsTodayDesc: 'Progress: {current}/{target} created today',
        enrollProspectToday: 'Enroll 1 prospect as a member today',
        enrollProspectTodayDesc: 'Progress: {current}/{target} enrolled as members today',
        advanceMemberToday: 'Advance 1 client stage today',
        advanceMemberTodayDesc: 'Progress: {current}/{target} advanced today',
        deliverGiftToday: 'Deliver 1 pending gift today',
        deliverGiftTodayDesc: 'Progress: {current}/{target} delivered today',
        reviewPendingGifts: 'Review pending gifts',
        reviewPendingGiftsDesc: '{count} gift(s) waiting for delivery',
        linkCopied: 'Invite link copied!',
        phoneCopied: 'Phone number copied!',
        noPhone: 'No phone number on file for this member',
        shareTitle: 'Share your invite link',
        shareSubtitle: 'Copy your link or share directly on social media.',
        vendorFallback: 'your representative',
        emailTemplates: {
          welcomeAffiliated: {
            subject: 'Welcome, {name}!',
            body: 'Hi {name},\n\nWe\'re thrilled to have you in our community! Your journey is about to begin and {vendorName} will be with you every step of the way.\n\nWelcome aboard!',
          },
          remindVisited: {
            subject: 'You\'re almost there, {name}!',
            body: 'Hi {name},\n\nGreat progress! You\'ve completed your visit and you\'re very close to finishing your journey. Reach out if you have any questions.\n\nKeep it up!',
          },
          congratulateCompleted: {
            subject: 'Congratulations, {name}!',
            body: 'Hi {name},\n\nCongratulations on completing your entire journey! Thank you for trusting us. We look forward to growing together.\n\nCheers!',
          },
          remindContacted: {
            subject: 'Reminder: {vendorName} will be in touch soon',
            body: 'Hi {name},\n\nJust a friendly reminder that {vendorName} will be reaching out to you soon about your visit. Please stay tuned for their call or visit.\n\nBest regards',
          },
        },
        missionLabels: {
          share_link_today: 'Share link today',
          invite_3_today: 'Invite 3 people today',
          browse_rewards_today: 'Browse rewards shop',
          welcome_affiliated: 'Welcome affiliated referral',
          remind_contacted: 'Remind contacted referral',
          remind_visited: 'Encourage visited referral',
          congratulate_completed: 'Congratulate completed referral',
          call_affiliated: 'Call affiliated member',
          call_contacted: 'Call contacted member',
          follow_up_visited: 'Follow up visited member',
          follow_up_completed: 'Follow up completed member',
          create_3_prospects_today: 'Create 3 prospects today',
          enroll_prospect_today: 'Enroll 1 prospect as member today',
          advance_member_today: 'Advance 1 client stage today',
          deliver_gift_today: 'Deliver 1 gift today',
          review_pending_gifts: 'Review pending gifts',
        },
        missionDescriptions: {
          share_link_today: 'Share referral link once per day',
          invite_3_today: 'Bonus when 3 people register via referral link in one day',
          browse_rewards_today: 'Visit the rewards shop once per day',
          welcome_affiliated: 'Send welcome email to affiliated referral',
          remind_contacted: 'Send a friendly email reminder to a referred member in contacted state',
          remind_visited: 'Send encouragement to a referred member in visited state',
          congratulate_completed: 'Congratulate a referral who completed their journey',
          call_affiliated: 'Copy phone and call an affiliated member',
          call_contacted: 'Copy phone and call a contacted member',
          follow_up_visited: 'Copy phone and follow up with a visited member',
          follow_up_completed: 'Copy phone and follow up with a completed member',
          create_3_prospects_today: 'Create 3 new prospects in one day',
          enroll_prospect_today: 'Enroll at least 1 prospect as a member today',
          advance_member_today: 'Advance at least 1 client to the next stage today',
          deliver_gift_today: 'Mark at least 1 pending gift as delivered today',
          review_pending_gifts: 'Review gifts waiting for delivery',
        },
      },
      vendorHome: {
        homeSubtitle: 'Create prospects, deliver gifts, and grow your sales pipeline.',
        welcomeEyebrow: 'Sales hub',
        welcomeTitle: 'Ready to sell, {name}?',
        welcomeSubtitle: 'Every new prospect and happy client moves you closer to your goals. Start with a quick action below.',
        statClients: 'Clients',
        statReferrals: 'Referrals',
        statCommission: 'Commission',
        quickActionsEyebrow: 'Move fast',
        quickActionsTitle: 'Quick actions',
        shortcutsEyebrow: 'Direct access',
        shortcutsTitle: 'Shortcuts',
        shortcutsSubtitle: 'Jump straight to the tools you use most every day.',
        createProspectEyebrow: 'New lead',
        createProspectTitle: 'Create prospect',
        createProspectSubtitle: 'Add a lead in seconds and track them through enrollment.',
        createProspectCta: 'New prospect',
        pendingGiftsEyebrow: 'Deliveries',
        pendingGiftsTitle: 'Pending gifts',
        pendingGiftsNone: 'No gifts waiting — your clients are all caught up.',
        pendingGiftsCount: '{count} to deliver · {awaiting} awaiting admin',
        pendingGiftsCta: 'Manage gifts',
        clientsEyebrow: 'Clients',
        clientsTitle: 'View clients',
        clientsSubtitle: 'Review your client book and their current status.',
        clientsCta: 'View clients',
        performanceEyebrow: 'This month',
        performanceTitle: 'Your performance',
        viewAnalytics: 'Full analytics',
        newClientsEyebrow: 'Pipeline',
        newClientsTitle: 'Recent clients',
        viewAllClients: 'All clients',
        noClientsYet: 'No clients yet — create a prospect or share your QR to get started.',
        inviteEyebrow: 'Grow faster',
        inviteTitle: 'Your referral QR',
        inviteSubtitle: 'Let prospects scan and join your program instantly.',
        scanToJoin: 'Scan to join as your client',
        openReferrals: 'Promo & referral programs',
        noInviteLink: 'Your referral link is being prepared.',
      },
      adminHome: {
        homeSubtitle: 'Your team, pipeline, and pending actions in one place.',
        welcomeEyebrow: 'Admin hub',
        welcomeTitle: 'Hi, {name}',
        welcomeSubtitle: 'See how your program is running and what needs your attention today.',
        statUsers: 'Users',
        statUsersSub: '{admins} administrators',
        statVendors: 'Representatives',
        statVendorsSub: 'Avg {avg} clients / representative',
        statClients: 'Clients',
        statClientsSub: '{rate}% link conversion',
        statReferrals: 'Referrals',
        statReferralsSub: '{active} active referrers',
        pipelineEyebrow: 'Pipeline',
        pipelineTitle: 'Clients by stage',
        vendorsEyebrow: 'Team',
        vendorsTitle: 'Top representatives',
        vendorsEmpty: 'No representative data yet',
        viewUsers: 'Manage users',
        viewAnalytics: 'Analytics',
        pendingGiftsEyebrow: 'Needs action',
        pendingGiftsTitle: 'Pending gift deliveries',
        pendingGiftsNone: 'No gifts awaiting admin handoff.',
        pendingGiftsCount: '{count} claim(s) need your review',
        pendingGiftsCta: 'Review pending gifts',
        systemConfigTitle: 'System configuration',
        systemConfigSubtitle: 'Prospect pipeline statuses',
        statusCount: '{active} active of {total} statuses configured',
        noStatuses: 'No statuses configured yet',
        configureSystem: 'Open system settings',
        inviteEyebrow: 'Invite clients',
        inviteTitle: 'Your invite QR',
        inviteSubtitle: 'Share the link or let them scan the code to join as clients.',
        scanToJoin: 'Scan to join your company',
        openReferrals: 'Enrola programs & links',
        noInviteLink: 'Your invite link is being prepared.',
        linksTitle: 'Referral links',
        activeLinksLabel: 'Active links',
        clicksLabel: 'Total clicks',
        conversionsLabel: 'Conversions',
        conversionRateLabel: 'Conversion rate',
        notificationsTitle: 'Notifications',
        unreadCount: '{count} unread alert(s)',
        noUnreadNotifications: 'No unread notifications',
        viewNotifications: 'View notifications',
      },
      programs: 'Referral programs',
      wallet: 'Wallet',
      club: 'Shopping club',
      promoCard: 'Promo & virtual card',
      enrolaHub: 'Enrola hub',
      adminHubPreview: 'Preview — figures and actions on this page are illustrative until the marketplace backend is connected.',
      adminHubSubtitle: 'Links, support, marketplace, wallet and campaigns',
      corporate: 'Corporate',
      giftsTitle: 'Available gifts',
      giftsSubtitle: 'Redeem your points for rewards (base rate: $1 = 100 pts). Enable cash incentive for partner programs when applicable.',
      pointsHistory: 'View points history',
      programCountdownTitle: 'Program {current}/{total}',
      programLastDay: 'Last day — close your referrals today',
      programDaysLeft: '{count} day(s) remaining to complete the program',
      programTip: '4/14 tip: each valid referral gets you closer to the next gift. Share today.',
      shareQuick: 'Quick share',
      shareSuggested: 'Suggested messages',
      sharePreview: 'Preview',
      copyMessage: 'Copy message',
      messageCopied: 'Message copied',
      copyFailed: 'Could not copy',
      redeemAvailable: 'Redeem (preview)',
      pointsNeeded: '{count} pts needed',
      cashIncentiveLabel: 'Cash incentive (partner recruitment)',
      cashIncentiveHint: 'Visual only: the company sets rules; this indicates preference for partner campaigns.',
      conversionRate: 'Conversion rate: $1 = 100 points. Refer more to unlock exclusive gifts.',
      nextRewardLevel: 'Next reward level',
      gamificationDesc: 'Persuasive messaging and gamification: advance to unlock more benefits. In production: in-app, SMS and email notifications.',
      pointsLabel: 'points',
      goalLabel: 'Goal {count} pts',
      referMore: 'Refer more to level up and access exclusive gifts.',
      programsSubtitle: 'Build trust with a clear flow: your tier, your numbers, and two links (clients and partners) with QR and share kit.',
      clicks: 'Clicks',
      clicksAllLinks: 'Across all your links',
      conversionsLabel: 'Conversions',
      conversionsViaLink: 'Sign-ups via your link',
      activePrograms: 'Active links',
      programsAvailable: 'Programs available',
      referralProgramsBtn: 'Referral programs',
      walletBtn: 'Wallet',
      shoppingClubBtn: 'Shopping club',
      viewAnalytics: 'View analytics',
      viewNetwork: 'View network',
      quickActions: 'Quick Actions',
      programClientsLabel: 'Client program',
      programPartnersLabel: 'Partner program',
      newClientsSubtitle: 'New clients',
      partnerRecruitmentSubtitle: 'Partner recruitment',
      linkCopied: 'Link copied',
      qrDownloaded: 'QR downloaded',
      copyLink: 'Copy link',
      share: 'Share',
      showQR: 'Show QR',
      hideQR: 'Hide QR',
      downloadQR: 'Download QR',
      defaultShareClients: 'Join my Enrola client program and get exclusive benefits: {url}',
      defaultSharePartners: 'Earn with the Enrola partner program. First 3 businesses: $250. Invitation: {url}',
      defaultShareFallback: 'Join with my Enrola link: {url}',
      suggestedMessage: 'Suggested message',
      copyMessageTitle: 'Copy message',
      referralsCount: '{count} referrals',
      totalReferralsLabel: 'Total referrals',
      yourReferrals: 'Your referrals',
      customLinkLabel: 'Custom link',
      copiedShort: 'Copied',
      copyShort: 'Copy',
      shareOn: 'Share on:',
      shareKitLabel: 'Share kit',
      invitationTitle: 'Invitation — {label}',
      shareModalHint: 'Copy the link or share in one tap.',
      yourLink: 'Your link',
      scanToOpen: 'Scan to open your invitation',
      programsPreviewTitle: 'Your programs (preview)',
      programsPreviewSubtitle: 'Two fixed links: clients and partners. Open the full section from the menu.',
      network: {
        eyebrow: 'Network',
        title: 'Your network',
        subtitle: 'People you invited to the platform',
        subtitleTimeline: 'Each invitee shows their path: registered → verified → reward delivered.',
        summary: 'Summary',
        active: 'Active',
        referralsGenerated: 'Referrals generated',
        members: 'Members',
        timelineHint: 'Pipeline status per invitee',
        total: 'Total',
        completed: 'Completed',
        noInviteesTitle: 'No invitees yet',
        noInviteesDesc: 'When someone uses your link and registers, they will appear here with step-by-step status.',
        shareMyLink: 'Share my link',
        pipeline: {
          registered: 'Registered',
          verified: 'Verified',
          rewardPaid: 'Reward delivered',
        },
      },
      shareKit: {
        defaultMessage: 'Join with my Enrola link: {url}',
        whatsapp: 'WhatsApp',
        telegram: 'Telegram',
        sms: 'SMS',
      },
      inviteContacts: {
        label: 'Invite my contacts',
        subtitle: 'Pick contacts on your phone and send them an SMS with your referral link.',
        loading: 'Opening contacts…',
        openingSms: 'Opening Messages with {count} contact(s)',
        openingMessages: 'Opening Messages — add your contacts and send',
        desktopCopied: 'Message copied — open it on your phone to send via SMS',
        failed: 'Could not open your contacts. Try again on your phone.',
        miniCard: {
          eyebrow: 'From your phone',
          title: 'Your contacts are one tap away',
          body: 'Pick friends and family from your list — your invite goes out by SMS in seconds.',
          contactsHint: 'Everyone in your address book',
          footerHint: 'You choose who receives the message',
          messageLanguage: 'Message language',
        },
      },
      referralTree: {
        dialogLabel: 'Direct referrals for {name}',
        title: 'Direct referrals',
        directCount: '· {count} direct referral(s)',
        close: 'Close referral tree',
        emptyTitle: 'No direct referrals yet',
        emptyDesc: 'Only people who signed up directly through this client will appear here.',
        sectionLabel: 'Direct referrals',
      },
      walletView: {
        subtitle: 'Points and money: enabled rewards and balance ready to withdraw (preview).',
        points: 'Points',
        pointsAccumulated: 'Accumulated in campaigns',
        readyToCollect: 'Ready to collect',
        withdrawRequestHint: 'Request withdrawal when enabled',
        moneyEnabled: 'Money enabled',
        moneyRules: 'Available per company rules',
        readyToWithdraw: 'Ready to withdraw',
        withdrawHint: 'Preview — withdrawal flow in production',
        recentMovements: 'Recent movements',
      },
      clubView: {
        subtitle: 'E-commerce for products and services with your wallet (preview).',
        product: 'Product',
        service: 'Service',
        buyWithWallet: 'Buy with points or money',
        elevateSubtitle:
          'Buy your Elevate Hispanos event ticket and join Evolución 90 from the shopping club.',
        elevateEyebrow: 'Event',
        elevateTitle: 'Elevate Hispanos',
        elevateEventLine: 'Las Vegas · November 14, 2026',
        elevateDescription: 'Purchase your pre-sale ticket now and secure your seat.',
        elevateBuyCta: 'Buy ticket',
        welcomeDiscountBadge: '{percent}% OFF welcome gift',
        welcomeDiscountDescription:
          'Your welcome gift is active: {percent}% off this event ticket.',
        welcomeDiscountBuyCta: 'Buy with {percent}% off',
        welcomeDiscountNextStep:
          'Open the Shopping Club and use your 10% off on the Elevate Hispanos ticket.',
        evolucion90Eyebrow: 'EVOLUCIÓN 90™ · Week 02',
        evolucion90Brand: 'Elantar Academy',
        evolucion90OverlayTitle: 'EVOLUCIÓN 90™',
        evolucion90WeekLabel: 'Week 02',
        evolucion90Title: 'From Producer to Leader',
        evolucion90EventLine: 'Thursday, August 27, 2026 · 5:00–6:30 PM (PT)',
        evolucion90Description:
          'Make the leap from producer to leader. Live Zoom session with Freddy Reynoso.',
        evolucion90Cta: 'Attend Evolucion 90',
      },
      corporateView: {
        subtitle: 'E-sign, after-sales and ELANTAR One integration (preview — enable per contract).',
        esignTitle: 'E-sign',
        esignDesc: 'Sign documents digitally from the portal.',
        afterSalesTitle: 'After-sales',
        services: 'Services',
        maintenance: 'Maintenance',
        warranties: 'Warranties',
        elantarOneTitle: 'ELANTAR One',
        elantarOneDesc: 'Unified corporate hub (preview).',
        esignExtendedDesc: 'Sales pre-qualification, contracts and warranties.',
        openPendingDocs: 'Open pending documents',
        newRequest: 'New request',
        elantarOneExtendedDesc: 'Recruitment creates an automatic user; client program creates a prospect (corporate).',
        syncInDevelopment: 'Sync in development',
      },
      promoView: {
        eyebrow: 'Representative',
        subtitle: 'Upload your photo, generate your promoter card and share links and QR per program.',
        profilePhoto: 'Profile photo',
        uploadPhoto: 'Upload photo',
        localDemoHint: 'Local demo image — production uses your account photo.',
        promoter: 'Promoter',
        vendorFallback: 'Representative',
        defaultShareMessage: 'I am an Enrola promoter — client program: {url}',
        settingsPhotoHint: 'Update your profile photo in Settings → Profile.',
      },
      partnerNetworkView: {
        eyebrow: 'Enrola',
        title: 'Partner network',
        subtitle: 'Partners you recruited and partner prospects pending enrollment.',
        newPartner: 'New partner',
        partnersCount: 'Recruited partners',
        pendingCount: 'Pending prospects',
        pendingTitle: 'Pending partner prospects',
        pendingSubtitle: 'Partner program signups waiting to be enrolled.',
        noPending: 'No pending partner prospects',
        noPendingDesc: 'New partner signups will appear here.',
        manage: 'Manage',
        partnersTitle: 'My partners',
        partnersSubtitle: 'Partners you directly recruited.',
        noPartners: 'No partners yet',
        noPartnersDesc: 'Share your partner link to start building your network.',
        partnerBadge: 'Partner',
        failedToLoad: 'Could not load your partner network',
      },
      tiers: {
        bronze: 'Bronze',
        silver: 'Silver',
        gold: 'Gold',
        gamification: 'Gamification',
        levelUpTitle: 'Refer to level up',
        progressSummary: '{count} referral(s) · Gold goal: {goal}',
        referralsShort: '{count} ref.',
        nextBenefit: 'Next benefit',
        referralsToUnlock: '{count} referral(s) needed to unlock',
        bronzeBonus: '+50 pts on first valid sign-up',
        silverBonus: '+100 pts bonus at Silver',
        goldBonus: 'Exclusive gifts at Gold',
        firstReferral: 'First referral',
        firstReferralBonus: '+50 pts on first valid sign-up',
        goldUnlockedTitle: 'Gold level reached',
        goldUnlockedDesc: 'Keep referring to maintain your tier benefits.',
        goldLevelBadge: 'Gold level!',
        allMilestonesUnlocked: 'You have unlocked all milestones',
        keepInviting: 'Keep inviting to grow your network',
        silverLevel: 'Silver level',
        goldLevel: 'Gold level',
        silverBonusClub: '10% extra coupon in the club',
        goldBonusMoney: '$25 bonus + exclusive badge',
      },
      linkCard: {
        linkCopiedToast: 'Link copied to clipboard!',
        copyFailed: 'Failed to copy link',
        qrDownloaded: 'QR Code downloaded!',
        shareTitle: 'Join with my referral link',
        shareText: 'Get exclusive benefits by joining through my referral!',
        views: 'Views',
        clicks: 'Clicks',
        conversions: 'Conversions',
        created: 'Created',
        copyLink: 'Copy link',
        showQrCode: 'Show QR code',
        hideQrCode: 'Hide QR code',
        downloadQr: 'Download QR',
        shareLink: 'Share link',
        referralCode: 'Code',
        scanQrHint: 'Scan this code to access your referral link',
        active: 'Active',
        inactive: 'Inactive',
        analytics: 'Analytics',
        referralLink: 'Referral link',
        expires: 'Expires',
        createdOn: 'Created',
        premium: 'Premium',
      },
    },
    referralMessages: {
      mutual: {
        label: 'Mutual favor',
        description: 'Short, ideal for close contacts',
        body: 'Hi [Nombre del Amigo/Contacto]! I urgently need your help to win my [Regalo a Ganar] with Enrola. If you accept a call from [Nombre del Representante/Asesor] (no obligation), you get a gift. Can you help me today? Thanks! [Tu Nombre]'
      },
      urgency: {
        label: 'Reward & urgency',
        description: 'Emphasizes the gift and program deadline',
        body: '[Nombre del Amigo/Contacto]! I\'m in the final stretch to win [Regalo a Ganar] (only 14 days left). Can you help? My advisor [Nombre del Representante/Asesor] will give you a gift just for listening for 10 minutes. You win, I win! Should I send you the contact? [Tu Nombre]'
      },
      direct: {
        label: 'Direct ask',
        description: 'Very direct to close fast',
        body: '[Nombre del Amigo/Contacto], please! I want to win [Regalo a Ganar] and need a referral. My advisor will call you to schedule a visit and give you a free gift. We both win prizes! Let me know if you can. [Tu Nombre]'
      },
      defaults: {
        contactName: '[Contact name]',
        giftName: '[Gift to win]',
        advisorName: '[Your advisor]',
        userName: '[Your name]'
      }
    },
    enterprise: {
      nav: {
        backToHome: 'Back to home',
        signIn: 'Sign in',
        userSignIn: 'User sign in',
        userPortalPrompt: 'Representative or client?',
      },
      hero: {
        badge: 'Multi-tenant platform',
        title1: 'Launch your referral program',
        titleHighlight: 'for your company',
        subtitle: 'Each company gets an isolated environment with its own users, clients, representatives, rewards, and analytics. Sign in with your admin email to get started.',
      },
      features: {
        isolated: {
          title: 'Isolated data',
          description: 'Every company starts fresh with its own database scope.',
        },
        team: {
          title: 'Full team management',
          description: 'Admins, representatives, and clients — all scoped to your organization.',
        },
        analytics: {
          title: 'Company analytics',
          description: 'Track referrals, conversions, and rewards within your tenant.',
        },
        security: {
          title: 'Enterprise security',
          description: 'Data separation by company with secure session isolation.',
        },
      },
      benefits: [
        'Instant setup — no credit card required',
        'Dedicated admin account for your company',
        'Pre-configured rewards and point system',
        'Scale from startup to enterprise',
      ],
      login: {
        tab: 'Sign in',
        title: 'Company admin sign in',
        subtitle: 'Enter your admin email and password to manage your organization.',
        submit: 'Sign in to admin panel',
        submitting: 'Signing in...',
        success: 'Welcome back!',
        error: 'Could not sign in',
        signInFailed: 'Could not sign in',
        cannotReachServer: 'Cannot reach server. Is the backend running?',
        noAccount: 'New company?',
      },
      form: {
        tab: 'Register',
        title: 'Create your company account',
        subtitle: 'Company name, admin email, and password required to get started.',
        companyName: 'Company name',
      companyRequired: 'Company name is required',
        companyNamePlaceholder: 'e.g. Acme Corporation',
        email: 'Admin email',
        emailPlaceholder: 'admin@yourcompany.com',
        password: 'Password',
        passwordPlaceholder: 'Minimum 6 characters',
        confirmPassword: 'Confirm password',
        confirmPasswordPlaceholder: 'Repeat your password',
        submit: 'Create company account',
        submitting: 'Creating account...',
        success: 'Company account created successfully!',
        error: 'Could not create company account',
        registrationFailed: 'Could not create company account',
        passwordMismatch: 'Passwords do not match',
        passwordTooShort: 'Password must be at least 6 characters',
        alreadyHaveAccount: 'Already have an account?',
        signInLink: 'Sign in',
      },
    },
  };

export default en;
